var xa = Object.defineProperty, Pa = Object.defineProperties;
var Ma = Object.getOwnPropertyDescriptors;
var ct = Object.getOwnPropertySymbols;
var Ar = Object.prototype.hasOwnProperty, Rr = Object.prototype.propertyIsEnumerable;
var Yt = (e, t, n) => t in e ? xa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, P = (e, t) => {
  for (var n in t || (t = {}))
    Ar.call(t, n) && Yt(e, n, t[n]);
  if (ct)
    for (var n of ct(t))
      Rr.call(t, n) && Yt(e, n, t[n]);
  return e;
}, H = (e, t) => Pa(e, Ma(t));
var Jt = (e, t) => {
  var n = {};
  for (var r in e)
    Ar.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && ct)
    for (var r of ct(e))
      t.indexOf(r) < 0 && Rr.call(e, r) && (n[r] = e[r]);
  return n;
};
var b = (e, t, n) => Yt(e, typeof t != "symbol" ? t + "" : t, n);
var j = (e, t, n) => new Promise((r, i) => {
  var o = (c) => {
    try {
      u(n.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(n.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(o, a);
  u((n = n.apply(e, t)).next());
});
const ka = ({ apiKey: e }) => {
  (function(t, n) {
    var r = t.amplitude || { _q: [], _iq: {} }, i = n.createElement("script");
    i.type = "text/javascript", i.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", i.crossOrigin = "anonymous", i.async = !0, i.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", i.onload = function() {
      t.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(e);
    };
    var o = n.getElementsByTagName("script")[0];
    o.parentNode.insertBefore(i, o);
    function a(p, m) {
      p.prototype[m] = function() {
        return this._q.push([m].concat(Array.prototype.slice.call(arguments, 0))), this;
      };
    }
    for (var u = function() {
      return this._q = [], this;
    }, c = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], s = 0; s < c.length; s++)
      a(u, c[s]);
    r.Identify = u;
    for (var l = function() {
      return this._q = [], this;
    }, f = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], d = 0; d < f.length; d++)
      a(l, f[d]);
    r.Revenue = l;
    var h = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function g(p) {
      function m(T) {
        p[T] = function() {
          p._q.push([T].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      for (var y = 0; y < h.length; y++)
        m(h[y]);
    }
    g(r), r.getInstance = function(p) {
      return p = (!p || p.length === 0 ? "$default_instance" : p).toLowerCase(), Object.prototype.hasOwnProperty.call(r._iq, p) || (r._iq[p] = { _q: [] }, g(r._iq[p])), r._iq[p];
    }, t.amplitude = r;
  })(window, document);
}, Da = ({ projectToken: e }) => {
  if (window.mixpanel)
    return;
  (function(n, r) {
    if (!r.__SV) {
      var i, o;
      window.mixpanel = r, r._i = [], r.init = function(a, u, c) {
        function s(d, h) {
          var g = h.split(".");
          g.length == 2 && (d = d[g[0]], h = g[1]), d[h] = function() {
            d.push([h].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var l = r;
        for (typeof c != "undefined" ? l = r[c] = [] : c = "mixpanel", l.people = l.people || [], l.toString = function(d) {
          var h = "mixpanel";
          return c !== "mixpanel" && (h += "." + c), d || (h += " (stub)"), h;
        }, l.people.toString = function() {
          return l.toString(1) + ".people (stub)";
        }, i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "), o = 0; o < i.length; o++)
          s(l, i[o]);
        var f = "set set_once union unset remove delete".split(" ");
        l.get_group = function() {
          function d(m) {
            h[m] = function() {
              call2_args = arguments, call2 = [m].concat(Array.prototype.slice.call(call2_args, 0)), l.push([g, call2]);
            };
          }
          for (var h = {}, g = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), p = 0; p < f.length; p++)
            d(f[p]);
          return h;
        }, r._i.push([a, u, c]);
      }, r.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const t = document.createElement("script");
  t.src = Ua, document.head.appendChild(t), t.addEventListener("load", () => {
    var n;
    (n = window.mixpanel) == null || n.init(e);
  });
}, Ua = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js", j_ = 1e3, $_ = 2e3, X_ = 144e5;
const z_ = {
  normal: {
    bytes: 1e7,
    time: 24e4
  },
  canvas: {
    bytes: 16e6,
    time: 5e3
  }
}, q_ = 100, Ba = "app.highlight.io";
function Ha(e, t, n) {
  try {
    if (!(t in e))
      return () => {
      };
    const r = e[t], i = n(r);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: r
      }
    })), e[t] = i, () => {
      e[t] = r;
    };
  } catch (r) {
    return () => {
    };
  }
}
function Fa(e) {
  if (!e || !e.outerHTML)
    return "";
  let t = "";
  for (; e.parentElement; ) {
    let n = e.localName;
    if (!n)
      break;
    n = n.toLowerCase();
    let r = e.parentElement, i = [];
    if (r.children && r.children.length > 0)
      for (let o = 0; o < r.children.length; o++) {
        let a = r.children[o];
        a.localName && a.localName.toLowerCase && a.localName.toLowerCase() === n && i.push(a);
      }
    i.length > 1 && (n += ":eq(" + i.indexOf(e) + ")"), t = n + (t ? ">" + t : ""), e = r;
  }
  return t;
}
function In(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Hi(e, t) {
  if (t === 0)
    return !0;
  const n = Object.keys(e);
  for (const r of n)
    if (In(e[r]) && Hi(e[r], t - 1))
      return !0;
  return !1;
}
function Kt(e, t) {
  const n = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(n, t);
  const r = [], i = [];
  return JSON.stringify(e, function(u, c) {
    if (r.length > 0) {
      const s = r.indexOf(this);
      ~s ? r.splice(s + 1) : r.push(this), ~s ? i.splice(s, 1 / 0, u) : i.push(u), ~r.indexOf(c) && (r[0] === c ? c = "[Circular ~]" : c = "[Circular ~." + i.slice(0, r.indexOf(c)).join(".") + "]");
    } else
      r.push(c);
    if (c == null)
      return c;
    if (o(c))
      return a(c);
    if (c instanceof Event) {
      const s = {};
      for (const l in c) {
        const f = c[l];
        Array.isArray(f) ? s[l] = Fa(f.length ? f[0] : null) : s[l] = f;
      }
      return s;
    } else {
      if (c instanceof Node)
        return c instanceof HTMLElement ? c ? c.outerHTML : "" : c.nodeName;
      if (c instanceof Error)
        return c.name + ": " + c.message;
    }
    return c;
  });
  function o(u) {
    return In(u) && Object.keys(u).length > n.numOfKeysLimit || typeof u == "function" ? !0 : u instanceof Event && u.isTrusted === !1 ? Object.keys(u).length === 1 : !!(In(u) && Hi(u, n.depthOfLimit));
  }
  function a(u) {
    let c = u.toString();
    return n.stringLengthLimit && c.length > n.stringLengthLimit && (c = `${c.slice(0, n.stringLengthLimit)}...`), c;
  }
}
function Ga() {
  var e = document.createElement("canvas");
  return e.getContext && e.getContext("2d") ? e.toDataURL("image/webp").indexOf("data:image/webp") == 0 : !1;
}
function W_() {
  return Ga() ? {
    type: "image/webp",
    quality: 0.9
  } : {
    type: "image/jpeg",
    quality: 0.6
  };
}
var Fi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Gi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vi = { exports: {} }, Qt = { exports: {} }, Nr;
function Va() {
  return Nr || (Nr = 1, function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(Fi, function() {
      function n(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function r(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function f(p) {
        if (p)
          for (var m = 0; m < l.length; m++)
            p[l[m]] !== void 0 && this["set" + r(l[m])](p[l[m]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof f)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new f(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", m = this.getLineNumber() || "", y = this.getColumnNumber() || "", T = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + m + ":" + y + ")" : "[eval]:" + m + ":" + y : T ? T + " (" + p + ":" + m + ":" + y + ")" : p + ":" + m + ":" + y;
        }
      }, f.fromString = function(m) {
        var y = m.indexOf("("), T = m.lastIndexOf(")"), R = m.substring(0, y), x = m.substring(y + 1, T).split(","), G = m.substring(T + 1);
        if (G.indexOf("@") === 0)
          var U = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(G, ""), ae = U[1], J = U[2], se = U[3];
        return new f({
          functionName: R,
          args: x || void 0,
          fileName: ae,
          lineNumber: J || void 0,
          columnNumber: se || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + r(o[d])] = i(o[d]), f.prototype["set" + r(o[d])] = /* @__PURE__ */ function(p) {
          return function(m) {
            this[p] = !!m;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        f.prototype["get" + r(a[h])] = i(a[h]), f.prototype["set" + r(a[h])] = /* @__PURE__ */ function(p) {
          return function(m) {
            if (!n(m))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(m);
          };
        }(a[h]);
      for (var g = 0; g < u.length; g++)
        f.prototype["get" + r(u[g])] = i(u[g]), f.prototype["set" + r(u[g])] = /* @__PURE__ */ function(p) {
          return function(m) {
            this[p] = String(m);
          };
        }(u[g]);
      return f;
    });
  }(Qt)), Qt.exports;
}
(function(e, t) {
  (function(n, r) {
    e.exports = r(Va());
  })(Fi, function(r) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = s.exec(c.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return s.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var h = f.split(/\s+/).slice(1), g = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, m = ["eval", "<anonymous>"].indexOf(g[0]) > -1 ? void 0 : g[0];
          return new r({
            functionName: p,
            fileName: m,
            lineNumber: g[1],
            columnNumber: g[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return s.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new r({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), h = d && d[1] ? d[1] : void 0, g = this.extractLocation(l.replace(f, ""));
          return new r({
            functionName: h,
            fileName: g[0],
            lineNumber: g[1],
            columnNumber: g[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, l = c.message.split(`
`), f = [], d = 2, h = l.length; d < h; d += 2) {
          var g = s.exec(l[d]);
          g && f.push(new r({
            fileName: g[2],
            lineNumber: g[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = c.stacktrace.split(`
`), f = [], d = 0, h = l.length; d < h; d += 2) {
          var g = s.exec(l[d]);
          g && f.push(
            new r({
              functionName: g[3] || void 0,
              fileName: g[2],
              lineNumber: g[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return s.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), h = f.shift() || "", g = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var m = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new r({
            functionName: g,
            args: m,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(Vi);
var ja = Vi.exports;
const Lr = /* @__PURE__ */ Gi(ja);
function Cn(e) {
  try {
    return Lr.parse(e);
  } catch (t) {
    try {
      return Lr.parse(new Error());
    } catch (n) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: n
      }), [];
    }
  }
}
function $a(e, t) {
  const n = t.logger;
  let r;
  r = window[n];
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = Cn(s));
      const f = [
        Kt(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(r, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? Ha(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        const l = Cn(new Error()), f = t.serializeConsoleAttributes ? s.map((d) => typeof d == "object" ? Kt(d, t.stringifyOptions) : d) : s.filter((d) => typeof d != "object").map((d) => `${d}`);
        e({
          type: u,
          trace: l.slice(1),
          value: f,
          attributes: Kt(s.filter((d) => typeof d == "object").reduce((d, h) => P(P({}, d), h), {}), t.stringifyOptions),
          time: Date.now()
        });
      } catch (l) {
        c("highlight logger error:", l, ...s);
      }
    }) : () => {
    };
  }
}
var xn = { exports: {} };
(function(e, t) {
  t = e.exports = n, t.getSerialize = r;
  function n(i, o, a, u) {
    return JSON.stringify(i, r(o, u), a);
  }
  function r(i, o) {
    var a = [], u = [];
    return o == null && (o = function(c, s) {
      return a[0] === s ? "[Circular ~]" : "[Circular ~." + u.slice(0, a.indexOf(s)).join(".") + "]";
    }), function(c, s) {
      if (a.length > 0) {
        var l = a.indexOf(this);
        ~l ? a.splice(l + 1) : a.push(this), ~l ? u.splice(l, 1 / 0, c) : u.push(c), ~a.indexOf(s) && (s = o.call(this, c, s));
      } else a.push(s);
      return i == null ? s : i.call(this, c, s);
    };
  }
})(xn, xn.exports);
var Xa = xn.exports;
const Nt = /* @__PURE__ */ Gi(Xa);
function Zt(e, t, n, r) {
  var u, c, s, l;
  let i = Cn(r != null ? r : t), o = {};
  t instanceof Error && (t = t.message, t.cause && (o = { "exception.cause": t.cause }));
  const a = qa(i);
  e({
    event: Nt(t),
    type: "window.onerror",
    url: window.location.href,
    source: n != null ? n : "",
    lineNumber: (u = a[0]) != null && u.lineNumber ? (c = a[0]) == null ? void 0 : c.lineNumber : 0,
    columnNumber: (s = a[0]) != null && s.columnNumber ? (l = a[0]) == null ? void 0 : l.columnNumber : 0,
    stackTrace: a,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: o ? Nt(o) : void 0
  });
}
const za = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined")
    return () => {
    };
  const n = window.onerror = (a, u, c, s, l) => {
    Zt(e, a, u, l);
  }, r = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? Zt(e, a.reason, a.type, u.getStack()) : Zt(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      b(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = r, window.onerror = n;
  };
}, qa = (e) => {
  var n, r;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (n = t.fileName) != null && n.includes("highlight.run") || (r = t.fileName) != null && r.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Ir = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Cr = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var Wa = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ye = "1.9.0", xr = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Ya(e) {
  var t = /* @__PURE__ */ new Set([e]), n = /* @__PURE__ */ new Set(), r = e.match(xr);
  if (!r)
    return function() {
      return !1;
    };
  var i = {
    major: +r[1],
    minor: +r[2],
    patch: +r[3],
    prerelease: r[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(u) {
    return n.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (n.has(c))
      return !1;
    var s = c.match(xr);
    if (!s)
      return o(c);
    var l = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
var Ja = Ya(ye), Ka = ye.split(".")[0], Qe = Symbol.for("opentelemetry.js.api." + Ka), Ze = Wa;
function ot(e, t, n, r) {
  var i;
  r === void 0 && (r = !1);
  var o = Ze[Qe] = (i = Ze[Qe]) !== null && i !== void 0 ? i : {
    version: ye
  };
  if (!r && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return n.error(a.stack || a.message), !1;
  }
  if (o.version !== ye) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + ye);
    return n.error(a.stack || a.message), !1;
  }
  return o[e] = t, n.debug("@opentelemetry/api: Registered a global for " + e + " v" + ye + "."), !0;
}
function ve(e) {
  var t, n, r = (t = Ze[Qe]) === null || t === void 0 ? void 0 : t.version;
  if (!(!r || !Ja(r)))
    return (n = Ze[Qe]) === null || n === void 0 ? void 0 : n[e];
}
function at(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + ye + ".");
  var n = Ze[Qe];
  n && delete n[e];
}
var Qa = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Za = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, es = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ue("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ue("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ue("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ue("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ue("verbose", this._namespace, t);
    }, e;
  }()
);
function Ue(e, t, n) {
  var r = ve("diag");
  if (r)
    return n.unshift(t), r[e].apply(r, Za([], Qa(n), !1));
}
var I;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(I || (I = {}));
function ts(e, t) {
  e < I.NONE ? e = I.NONE : e > I.ALL && (e = I.ALL), t = t || {};
  function n(r, i) {
    var o = t[r];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: n("error", I.ERROR),
    warn: n("warn", I.WARN),
    info: n("info", I.INFO),
    debug: n("debug", I.DEBUG),
    verbose: n("verbose", I.VERBOSE)
  };
}
var ns = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, rs = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, is = "diag", ee = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = ve("diag");
          if (u)
            return u[i].apply(u, rs([], ns(o), !1));
        };
      }
      var n = this, r = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: I.INFO }), i === n) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return n.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = ve("diag"), f = ts((u = o.logLevel) !== null && u !== void 0 ? u : I.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return ot("diag", f, n, !0);
      };
      n.setLogger = r, n.disable = function() {
        at(is, n);
      }, n.createComponentLogger = function(i) {
        return new es(i);
      }, n.verbose = t("verbose"), n.debug = t("debug"), n.info = t("info"), n.warn = t("warn"), n.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), os = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, as = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ss = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var n = this._entries.get(t);
      if (n)
        return Object.assign({}, n);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var n = os(t, 2), r = n[0], i = n[1];
        return [r, i];
      });
    }, e.prototype.setEntry = function(t, n) {
      var r = new e(this._entries);
      return r._entries.set(t, n), r;
    }, e.prototype.removeEntry = function(t) {
      var n = new e(this._entries);
      return n._entries.delete(t), n;
    }, e.prototype.removeEntries = function() {
      for (var t, n, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = as(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), us = Symbol("BaggageEntryMetadata"), cs = ee.instance();
function ls(e) {
  return e === void 0 && (e = {}), new ss(new Map(Object.entries(e)));
}
function fs(e) {
  return typeof e != "string" && (cs.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: us,
    toString: function() {
      return e;
    }
  };
}
function ar(e) {
  return Symbol.for(e);
}
var ds = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var n = this;
      n._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), n.getValue = function(r) {
        return n._currentContext.get(r);
      }, n.setValue = function(r, i) {
        var o = new e(n._currentContext);
        return o._currentContext.set(r, i), o;
      }, n.deleteValue = function(r) {
        var i = new e(n._currentContext);
        return i._currentContext.delete(r), i;
      };
    }
    return e;
  }()
), pe = new ds(), be = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), hs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, n) {
      return Ss;
    }, e.prototype.createHistogram = function(t, n) {
      return ws;
    }, e.prototype.createCounter = function(t, n) {
      return Ts;
    }, e.prototype.createUpDownCounter = function(t, n) {
      return bs;
    }, e.prototype.createObservableGauge = function(t, n) {
      return As;
    }, e.prototype.createObservableCounter = function(t, n) {
      return Os;
    }, e.prototype.createObservableUpDownCounter = function(t, n) {
      return Rs;
    }, e.prototype.addBatchObservableCallback = function(t, n) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), Ht = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), ps = (
  /** @class */
  function(e) {
    be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(n, r) {
    }, t;
  }(Ht)
), _s = (
  /** @class */
  function(e) {
    be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(n, r) {
    }, t;
  }(Ht)
), gs = (
  /** @class */
  function(e) {
    be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(n, r) {
    }, t;
  }(Ht)
), ys = (
  /** @class */
  function(e) {
    be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(n, r) {
    }, t;
  }(Ht)
), sr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), ms = (
  /** @class */
  function(e) {
    be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(sr)
), vs = (
  /** @class */
  function(e) {
    be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(sr)
), Es = (
  /** @class */
  function(e) {
    be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(sr)
), ji = new hs(), Ts = new ps(), Ss = new gs(), ws = new ys(), bs = new _s(), Os = new ms(), As = new vs(), Rs = new Es();
function Ns() {
  return ji;
}
var fe;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(fe || (fe = {}));
var Ls = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, Is = {
  set: function(e, t, n) {
    e != null && (e[t] = n);
  }
}, Cs = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, xs = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ps = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return pe;
    }, e.prototype.with = function(t, n, r) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return n.call.apply(n, xs([r], Cs(i), !1));
    }, e.prototype.bind = function(t, n) {
      return n;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Ms = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ks = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, en = "context", Ds = new Ps(), Ft = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return ot(en, t, ee.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, n, r) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, ks([t, n, r], Ms(o), !1));
    }, e.prototype.bind = function(t, n) {
      return this._getContextManager().bind(t, n);
    }, e.prototype._getContextManager = function() {
      return ve(en) || Ds;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), at(en, ee.instance());
    }, e;
  }()
), ie;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(ie || (ie = {}));
var $i = "0000000000000000", Xi = "00000000000000000000000000000000", zi = {
  traceId: Xi,
  spanId: $i,
  traceFlags: ie.NONE
}, ze = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = zi), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, n) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, n) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, n) {
    }, e;
  }()
), ur = ar("OpenTelemetry Context Key SPAN");
function cr(e) {
  return e.getValue(ur) || void 0;
}
function Us() {
  return cr(Ft.getInstance().active());
}
function lr(e, t) {
  return e.setValue(ur, t);
}
function Bs(e) {
  return e.deleteValue(ur);
}
function Hs(e, t) {
  return lr(e, new ze(t));
}
function qi(e) {
  var t;
  return (t = cr(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Fs = /^([0-9a-f]{32})$/i, Gs = /^[0-9a-f]{16}$/i;
function Wi(e) {
  return Fs.test(e) && e !== Xi;
}
function Vs(e) {
  return Gs.test(e) && e !== $i;
}
function Gt(e) {
  return Wi(e.traceId) && Vs(e.spanId);
}
function js(e) {
  return new ze(e);
}
var tn = Ft.getInstance(), Yi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, n, r) {
      r === void 0 && (r = tn.active());
      var i = !!(n != null && n.root);
      if (i)
        return new ze();
      var o = r && qi(r);
      return $s(o) && Gt(o) ? new ze(o) : new ze();
    }, e.prototype.startActiveSpan = function(t, n, r, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = n : arguments.length === 3 ? (o = n, u = r) : (o = n, a = r, u = i);
        var c = a != null ? a : tn.active(), s = this.startSpan(t, o, c), l = lr(c, s);
        return tn.with(l, u, void 0, s);
      }
    }, e;
  }()
);
function $s(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Xs = new Yi(), zs = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      this._provider = t, this.name = n, this.version = r, this.options = i;
    }
    return e.prototype.startSpan = function(t, n, r) {
      return this._getTracer().startSpan(t, n, r);
    }, e.prototype.startActiveSpan = function(t, n, r, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Xs;
    }, e;
  }()
), qs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, n, r) {
      return new Yi();
    }, e;
  }()
), Ws = new qs(), Pr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, n, r) {
      var i;
      return (i = this.getDelegateTracer(t, n, r)) !== null && i !== void 0 ? i : new zs(this, t, n, r);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Ws;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, n, r) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, n, r);
    }, e;
  }()
), Lt;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Lt || (Lt = {}));
var et;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(et || (et = {}));
var Pn;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(Pn || (Pn = {}));
var A = Ft.getInstance(), v = ee.instance(), Ys = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, n, r) {
      return ji;
    }, e;
  }()
), Js = new Ys(), nn = "metrics", Ks = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return ot(nn, t, ee.instance());
    }, e.prototype.getMeterProvider = function() {
      return ve(nn) || Js;
    }, e.prototype.getMeter = function(t, n, r) {
      return this.getMeterProvider().getMeter(t, n, r);
    }, e.prototype.disable = function() {
      at(nn, ee.instance());
    }, e;
  }()
), fr = Ks.getInstance(), Qs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, n) {
    }, e.prototype.extract = function(t, n) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), dr = ar("OpenTelemetry Baggage Key");
function Ji(e) {
  return e.getValue(dr) || void 0;
}
function Zs() {
  return Ji(Ft.getInstance().active());
}
function eu(e, t) {
  return e.setValue(dr, t);
}
function tu(e) {
  return e.deleteValue(dr);
}
var rn = "propagation", nu = new Qs(), ru = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = ls, this.getBaggage = Ji, this.getActiveBaggage = Zs, this.setBaggage = eu, this.deleteBaggage = tu;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return ot(rn, t, ee.instance());
    }, e.prototype.inject = function(t, n, r) {
      return r === void 0 && (r = Is), this._getGlobalPropagator().inject(t, n, r);
    }, e.prototype.extract = function(t, n, r) {
      return r === void 0 && (r = Ls), this._getGlobalPropagator().extract(t, n, r);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      at(rn, ee.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return ve(rn) || nu;
    }, e;
  }()
), X = ru.getInstance(), on = "trace", iu = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new Pr(), this.wrapSpanContext = js, this.isSpanContextValid = Gt, this.deleteSpan = Bs, this.getSpan = cr, this.getActiveSpan = Us, this.getSpanContext = qi, this.setSpan = lr, this.setSpanContext = Hs;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var n = ot(on, this._proxyTracerProvider, ee.instance());
      return n && this._proxyTracerProvider.setDelegate(t), n;
    }, e.prototype.getTracerProvider = function() {
      return ve(on) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, n) {
      return this.getTracerProvider().getTracer(t, n);
    }, e.prototype.disable = function() {
      at(on, ee.instance()), this._proxyTracerProvider = new Pr();
    }, e;
  }()
), L = iu.getInstance(), Ki = ar("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Qi(e) {
  return e.setValue(Ki, !0);
}
function hr(e) {
  return e.getValue(Ki) === !0;
}
var ou = "=", Mn = ";", kn = ",", an = "baggage", au = 180, su = 4096, uu = 8192, cu = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function lu(e) {
  return e.reduce(function(t, n) {
    var r = "" + t + (t !== "" ? kn : "") + n;
    return r.length > uu ? t : r;
  }, "");
}
function fu(e) {
  return e.getAllEntries().map(function(t) {
    var n = cu(t, 2), r = n[0], i = n[1], o = encodeURIComponent(r) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += Mn + i.metadata.toString()), o;
  });
}
function du(e) {
  var t = e.split(Mn);
  if (!(t.length <= 0)) {
    var n = t.shift();
    if (n) {
      var r = n.indexOf(ou);
      if (!(r <= 0)) {
        var i = decodeURIComponent(n.substring(0, r).trim()), o = decodeURIComponent(n.substring(r + 1).trim()), a;
        return t.length > 0 && (a = fs(t.join(Mn))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Zi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, n, r) {
      var i = X.getBaggage(t);
      if (!(!i || hr(t))) {
        var o = fu(i).filter(function(u) {
          return u.length <= su;
        }).slice(0, au), a = lu(o);
        a.length > 0 && r.set(n, an, a);
      }
    }, e.prototype.extract = function(t, n, r) {
      var i = r.get(n, an), o = Array.isArray(i) ? i.join(kn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(kn);
      return u.forEach(function(c) {
        var s = du(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : X.setBaggage(t, X.createBaggage(a));
    }, e.prototype.fields = function() {
      return [an];
    }, e;
  }()
), eo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, hu = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function St(e) {
  var t, n, r = {};
  if (typeof e != "object" || e == null)
    return r;
  try {
    for (var i = eo(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = hu(o.value, 2), u = a[0], c = a[1];
      if (!pu(u)) {
        v.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!to(c)) {
        v.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? r[u] = c.slice() : r[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
function pu(e) {
  return typeof e == "string" && e.length > 0;
}
function to(e) {
  return e == null ? !0 : Array.isArray(e) ? _u(e) : no(e);
}
function _u(e) {
  var t, n, r;
  try {
    for (var i = eo(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!r) {
          if (no(a)) {
            r = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== r)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function no(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function gu() {
  return function(e) {
    v.error(yu(e));
  };
}
function yu(e) {
  return typeof e == "string" ? e : JSON.stringify(mu(e));
}
function mu(e) {
  for (var t = {}, n = e; n !== null; )
    Object.getOwnPropertyNames(n).forEach(function(r) {
      if (!t[r]) {
        var i = n[r];
        i && (t[r] = String(i));
      }
    }), n = Object.getPrototypeOf(n);
  return t;
}
var vu = gu();
function de(e) {
  try {
    vu(e);
  } catch (t) {
  }
}
var Q;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(Q || (Q = {}));
var Eu = ",", Tu = ["OTEL_SDK_DISABLED"];
function Su(e) {
  return Tu.indexOf(e) > -1;
}
var wu = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function bu(e) {
  return wu.indexOf(e) > -1;
}
var Ou = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function Au(e) {
  return Ou.indexOf(e) > -1;
}
var wt = 1 / 0, bt = 128, Ru = 128, Nu = 128, ro = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: I.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: wt,
  OTEL_ATTRIBUTE_COUNT_LIMIT: bt,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: wt,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: bt,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: wt,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: bt,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Ru,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Nu,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: Q.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function Lu(e, t, n) {
  if (typeof n[e] != "undefined") {
    var r = String(n[e]);
    t[e] = r.toLowerCase() === "true";
  }
}
function Iu(e, t, n, r, i) {
  if (r === void 0 && (r = -1 / 0), i === void 0 && (i = 1 / 0), typeof n[e] != "undefined") {
    var o = Number(n[e]);
    isNaN(o) || (o < r ? t[e] = r : o > i ? t[e] = i : t[e] = o);
  }
}
function Cu(e, t, n, r) {
  r === void 0 && (r = Eu);
  var i = n[e];
  typeof i == "string" && (t[e] = i.split(r).map(function(o) {
    return o.trim();
  }));
}
var xu = {
  ALL: I.ALL,
  VERBOSE: I.VERBOSE,
  DEBUG: I.DEBUG,
  INFO: I.INFO,
  WARN: I.WARN,
  ERROR: I.ERROR,
  NONE: I.NONE
};
function Pu(e, t, n) {
  var r = n[e];
  if (typeof r == "string") {
    var i = xu[r.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function io(e) {
  var t = {};
  for (var n in ro) {
    var r = n;
    switch (r) {
      case "OTEL_LOG_LEVEL":
        Pu(r, t, e);
        break;
      default:
        if (Su(r))
          Lu(r, t, e);
        else if (bu(r))
          Iu(r, t, e);
        else if (Au(r))
          Cu(r, t, e);
        else {
          var i = e[r];
          typeof i != "undefined" && i !== null && (t[r] = String(i));
        }
    }
  }
  return t;
}
var qe = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function xe() {
  var e = io(qe);
  return Object.assign({}, ro, e);
}
function Mu() {
  return io(qe);
}
function Mr(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function pr(e) {
  for (var t = new Uint8Array(e.length / 2), n = 0, r = 0; r < e.length; r += 2) {
    var i = Mr(e.charCodeAt(r)), o = Mr(e.charCodeAt(r + 1));
    t[n++] = i << 4 | o;
  }
  return t;
}
var q = performance, ku = "1.30.1", Du = "exception.type", Uu = "exception.message", Bu = "exception.stacktrace", Hu = "http.method", Fu = "http.url", Gu = "http.host", Vu = "http.scheme", ju = "http.status_code", $u = "http.user_agent", Xu = "http.request_content_length_uncompressed", zu = "http.response_content_length", qu = "http.response_content_length_uncompressed", sn = Du, un = Uu, Wu = Bu, oo = Hu, We = Fu, ao = Gu, so = Vu, uo = ju, _r = $u, co = Xu, Yu = zu, Ju = qu, Ku = "deployment.environment", Qu = "process.runtime.name", Zu = "service.name", ec = "telemetry.sdk.name", tc = "telemetry.sdk.language", nc = "telemetry.sdk.version", rc = Ku, ic = Qu, oc = Zu, Dn = ec, Un = tc, Bn = nc, ac = "webjs", sc = ac, uc = "service.name", cc = "url.full", lc = "url.path", fc = "url.query", Ne, cn = (Ne = {}, Ne[Dn] = "opentelemetry", Ne[ic] = "browser", Ne[Un] = sc, Ne[Bn] = ku, Ne), dc = 9, hc = 6, pc = Math.pow(10, hc), It = Math.pow(10, dc);
function z(e) {
  var t = e / 1e3, n = Math.trunc(t), r = Math.round(e % 1e3 * pc);
  return [n, r];
}
function gr() {
  var e = q.timeOrigin;
  if (typeof e != "number") {
    var t = q;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Ee(e) {
  var t = z(gr()), n = z(typeof e == "number" ? e : q.now());
  return lo(t, n);
}
function Ye(e) {
  if (yr(e))
    return e;
  if (typeof e == "number")
    return e < gr() ? Ee(e) : z(e);
  if (e instanceof Date)
    return z(e.getTime());
  throw TypeError("Invalid input type");
}
function _c(e, t) {
  var n = t[0] - e[0], r = t[1] - e[1];
  return r < 0 && (n -= 1, r += It), [n, r];
}
function re(e) {
  return e[0] * It + e[1];
}
function lt(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function yr(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function kr(e) {
  return yr(e) || typeof e == "number" || e instanceof Date;
}
function lo(e, t) {
  var n = [e[0] + t[0], e[1] + t[1]];
  return n[1] >= It && (n[1] -= It, n[0] += 1), n;
}
var V;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(V || (V = {}));
var gc = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, fo = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var n;
      this._propagators = (n = t.propagators) !== null && n !== void 0 ? n : [], this._fields = Array.from(new Set(this._propagators.map(function(r) {
        return typeof r.fields == "function" ? r.fields() : [];
      }).reduce(function(r, i) {
        return r.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, n, r) {
      var i, o;
      try {
        for (var a = gc(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, n, r);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, n, r) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, n, r);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), Hn = "[_0-9a-z-*/]", yc = "[a-z]" + Hn + "{0,255}", mc = "[a-z0-9]" + Hn + "{0,240}@[a-z]" + Hn + "{0,13}", vc = new RegExp("^(?:" + yc + "|" + mc + ")$"), Ec = /^[ -~]{0,255}[!-~]$/, Tc = /,|=/;
function Sc(e) {
  return vc.test(e);
}
function wc(e) {
  return Ec.test(e) && !Tc.test(e);
}
var Dr = 32, bc = 512, Ur = ",", Br = "=", Oc = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, n) {
      var r = this._clone();
      return r._internalState.has(t) && r._internalState.delete(t), r._internalState.set(t, n), r;
    }, e.prototype.unset = function(t) {
      var n = this._clone();
      return n._internalState.delete(t), n;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(n, r) {
        return n.push(r + Br + t.get(r)), n;
      }, []).join(Ur);
    }, e.prototype._parse = function(t) {
      t.length > bc || (this._internalState = t.split(Ur).reverse().reduce(function(n, r) {
        var i = r.trim(), o = i.indexOf(Br);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, r.length);
          Sc(a) && wc(u) && n.set(a, u);
        }
        return n;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Dr && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Dr))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Ot = "traceparent", ln = "tracestate", Ac = "00", Rc = "(?!ff)[\\da-f]{2}", Nc = "(?![0]{32})[\\da-f]{32}", Lc = "(?![0]{16})[\\da-f]{16}", Ic = "[\\da-f]{2}", Cc = new RegExp("^\\s?(" + Rc + ")-(" + Nc + ")-(" + Lc + ")-(" + Ic + ")(-.*)?\\s?$");
function xc(e) {
  var t = Cc.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var ho = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, n, r) {
      var i = L.getSpanContext(t);
      if (!(!i || hr(t) || !Gt(i))) {
        var o = Ac + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || ie.NONE).toString(16);
        r.set(n, Ot, o), i.traceState && r.set(n, ln, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, n, r) {
      var i = r.get(n, Ot);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = xc(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = r.get(n, ln);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Oc(typeof c == "string" ? c : void 0);
      }
      return L.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Ot, ln];
    }, e;
  }()
), Pc = "[object Object]", Mc = "[object Null]", kc = "[object Undefined]", Dc = Function.prototype, po = Dc.toString, Uc = po.call(Object), Bc = Hc(Object.getPrototypeOf, Object), _o = Object.prototype, go = _o.hasOwnProperty, _e = Symbol ? Symbol.toStringTag : void 0, yo = _o.toString;
function Hc(e, t) {
  return function(n) {
    return e(t(n));
  };
}
function Hr(e) {
  if (!Fc(e) || Gc(e) !== Pc)
    return !1;
  var t = Bc(e);
  if (t === null)
    return !0;
  var n = go.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && po.call(n) === Uc;
}
function Fc(e) {
  return e != null && typeof e == "object";
}
function Gc(e) {
  return e == null ? e === void 0 ? kc : Mc : _e && _e in Object(e) ? Vc(e) : jc(e);
}
function Vc(e) {
  var t = go.call(e, _e), n = e[_e], r = !1;
  try {
    e[_e] = void 0, r = !0;
  } catch (o) {
  }
  var i = yo.call(e);
  return r && (t ? e[_e] = n : delete e[_e]), i;
}
function jc(e) {
  return yo.call(e);
}
var $c = 20;
function Xc() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n = e.shift(), r = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    n = mo(n, e.shift(), 0, r);
  return n;
}
function fn(e) {
  return Ct(e) ? e.slice() : e;
}
function mo(e, t, n, r) {
  n === void 0 && (n = 0);
  var i;
  if (!(n > $c)) {
    if (n++, At(e) || At(t) || vo(t))
      i = fn(t);
    else if (Ct(e)) {
      if (i = e.slice(), Ct(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(fn(t[o]));
      else if (Be(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = fn(t[c]);
        }
    } else if (Be(e))
      if (Be(t)) {
        if (!zc(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (At(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (Fr(e, c, r) || Fr(t, c, r))
              delete i[c];
            else {
              if (Be(l) && Be(f)) {
                var d = r.get(l) || [], h = r.get(f) || [];
                d.push({ obj: e, key: c }), h.push({ obj: t, key: c }), r.set(l, d), r.set(f, h);
              }
              i[c] = mo(i[c], s, n, r);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Fr(e, t, n) {
  for (var r = n.get(e[t]) || [], i = 0, o = r.length; i < o; i++) {
    var a = r[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function Ct(e) {
  return Array.isArray(e);
}
function vo(e) {
  return typeof e == "function";
}
function Be(e) {
  return !At(e) && !Ct(e) && !vo(e) && typeof e == "object";
}
function At(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function zc(e, t) {
  return !(!Hr(e) || !Hr(t));
}
var qc = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Eo(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function To(e, t) {
  var n, r;
  if (!t)
    return !1;
  try {
    for (var i = qc(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (Eo(e, a))
        return !0;
    }
  } catch (u) {
    n = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (n) throw n.error;
    }
  }
  return !1;
}
var Wc = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(n, r) {
        t._resolve = n, t._reject = r;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), Yc = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Jc = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Kc = (
  /** @class */
  function() {
    function e(t, n) {
      this._callback = t, this._that = n, this._isCalled = !1, this._deferred = new Wc();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, Jc([this._that], Yc(r), !1))).then(function(o) {
            return n._deferred.resolve(o);
          }, function(o) {
            return n._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
);
function Qc(e, t) {
  return new Promise(function(n) {
    A.with(Qi(A.active()), function() {
      e.export(t, function(r) {
        n(r);
      });
    });
  });
}
var Zc = {
  _export: Qc
}, So = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), el = new So(), tl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, n, r) {
      return new So();
    }, e;
  }()
), wo = new tl(), nl = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      this._provider = t, this.name = n, this.version = r, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : el;
    }, e;
  }()
), Gr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, n, r) {
      var i;
      return (i = this.getDelegateLogger(t, n, r)) !== null && i !== void 0 ? i : new nl(this, t, n, r);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : wo;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, n, r) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, n, r);
    }, e;
  }()
), rl = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ft = Symbol.for("io.opentelemetry.js.api.logs"), He = rl;
function il(e, t, n) {
  return function(r) {
    return r === e ? t : n;
  };
}
var Vr = 1, ol = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new Gr();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return He[ft] ? this.getLoggerProvider() : (He[ft] = il(Vr, t, wo), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, n;
      return (n = (t = He[ft]) === null || t === void 0 ? void 0 : t.call(He, Vr)) !== null && n !== void 0 ? n : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, n, r) {
      return this.getLoggerProvider().getLogger(t, n, r);
    }, e.prototype.disable = function() {
      delete He[ft], this._proxyLoggerProvider = new Gr();
    }, e;
  }()
), bo = ol.getInstance();
function al(e, t, n, r) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), n && a.setMeterProvider(n), r && a.setLoggerProvider && a.setLoggerProvider(r), a.getConfig().enabled || a.enable();
  }
}
function sl(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function ul(e) {
  var t, n, r = e.tracerProvider || L.getTracerProvider(), i = e.meterProvider || fr.getMeterProvider(), o = e.loggerProvider || bo.getLoggerProvider(), a = (n = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && n !== void 0 ? n : [];
  return al(a, r, i, o), function() {
    sl(a);
  };
}
function Fn(e) {
  return typeof e == "function";
}
var B = console.error.bind(console);
function Fe(e, t, n) {
  var r = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: r,
    writable: !0,
    value: n
  });
}
function st(e) {
  e && e.logger && (Fn(e.logger) ? B = e.logger : B("new logger isn't a function, not replacing"));
}
function Oo(e, t, n) {
  if (!e || !e[t]) {
    B("no original function " + t + " to wrap");
    return;
  }
  if (!n) {
    B("no wrapper function"), B(new Error().stack);
    return;
  }
  if (!Fn(e[t]) || !Fn(n)) {
    B("original object and wrapper must be functions");
    return;
  }
  var r = e[t], i = n(r, t);
  return Fe(i, "__original", r), Fe(i, "__unwrap", function() {
    e[t] === i && Fe(e, t, r);
  }), Fe(i, "__wrapped", !0), Fe(e, t, i), i;
}
function cl(e, t, n) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    B("must provide one or more modules to patch"), B(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    B("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(i) {
      Oo(r, i, n);
    });
  });
}
function Ao(e, t) {
  if (!e || !e[t]) {
    B("no function to unwrap."), B(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    B("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function ll(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    B("must provide one or more modules to patch"), B(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    B("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(r) {
      Ao(n, r);
    });
  });
}
st.wrap = Oo;
st.massWrap = cl;
st.unwrap = Ao;
st.massUnwrap = ll;
var dt = st, Gn = function() {
  return Gn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Gn.apply(this, arguments);
}, fl = (
  /** @class */
  function() {
    function e(t, n, r) {
      this.instrumentationName = t, this.instrumentationVersion = n, this._config = {}, this._wrap = dt.wrap, this._unwrap = dt.unwrap, this._massWrap = dt.massWrap, this._massUnwrap = dt.massUnwrap, this.setConfig(r), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = L.getTracer(t, n), this._meter = fr.getMeter(t, n), this._logger = bo.getLogger(t, n), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, n = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(n) ? n : [n];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Gn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, n, r, i) {
      if (t)
        try {
          t(r, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: n }, o);
        }
    }, e;
  }()
), dl = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Vt = (
  /** @class */
  function(e) {
    dl(t, e);
    function t(n, r, i) {
      var o = e.call(this, n, r, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(fl)
);
function xt(e, t, n) {
  var r, i;
  try {
    i = e();
  } catch (o) {
    r = o;
  } finally {
    return t(r, i), i;
  }
}
function M(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var hl = "exception", Vn = function() {
  return Vn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Vn.apply(this, arguments);
}, pl = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, jr = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _l = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, gl = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: Pn.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = r, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var f = Date.now();
      this._performanceStartTime = q.now(), this._performanceOffset = f - (this._performanceStartTime + gr()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, n);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, n) {
      return n == null || this._isSpanEnded() ? this : t.length === 0 ? (v.warn("Invalid attribute key: " + t), this) : to(n) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(n), this) : (v.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var n, r;
      try {
        for (var i = pl(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = jr(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        n = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (n) throw n.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, n, r) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return v.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && v.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), kr(n) && (kr(r) || (r = n), n = void 0);
      var i = St(n);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(r),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var n;
      return (n = this.links).push.apply(n, _l([], jr(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = Vn({}, t), this.status.message != null && typeof t.message != "string" && (v.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        v.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = _c(this.startTime, this.endTime), this._duration[0] < 0 && (v.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && v.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= q.now())
        return Ee(t + this._performanceOffset);
      if (typeof t == "number")
        return z(t);
      if (t instanceof Date)
        return z(t.getTime());
      if (yr(t))
        return t;
      if (this._startTimeProvided)
        return z(Date.now());
      var n = q.now() - this._performanceStartTime;
      return lo(this.startTime, z(n));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, n) {
      var r = {};
      typeof t == "string" ? r[un] = t : t && (t.code ? r[sn] = t.code.toString() : t.name && (r[sn] = t.name), t.message && (r[un] = t.message), t.stack && (r[Wu] = t.stack)), r[sn] || r[un] ? this.addEvent(hl, r, n) : v.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && v.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, n) {
      return t.length <= n ? t : t.substring(0, n);
    }, e.prototype._truncateToSize = function(t) {
      var n = this, r = this._attributeValueLengthLimit;
      return r <= 0 ? (v.warn("Attribute value limit must be positive, got " + r), t) : typeof t == "string" ? this._truncateToLimitUtil(t, r) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? n._truncateToLimitUtil(i, r) : i;
      }) : t;
    }, e;
  }()
), Pe;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Pe || (Pe = {}));
var Pt = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Pe.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), Ce = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Pe.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), dn = (
  /** @class */
  function() {
    function e(t) {
      var n, r, i, o;
      this._root = t.root, this._root || (de(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new Ce()), this._remoteParentSampled = (n = t.remoteParentSampled) !== null && n !== void 0 ? n : new Ce(), this._remoteParentNotSampled = (r = t.remoteParentNotSampled) !== null && r !== void 0 ? r : new Pt(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new Ce(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new Pt();
    }
    return e.prototype.shouldSample = function(t, n, r, i, o, a) {
      var u = L.getSpanContext(t);
      return !u || !Gt(u) ? this._root.shouldSample(t, n, r, i, o, a) : u.isRemote ? u.traceFlags & ie.SAMPLED ? this._remoteParentSampled.shouldSample(t, n, r, i, o, a) : this._remoteParentNotSampled.shouldSample(t, n, r, i, o, a) : u.traceFlags & ie.SAMPLED ? this._localParentSampled.shouldSample(t, n, r, i, o, a) : this._localParentNotSampled.shouldSample(t, n, r, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), $r = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, n) {
      return {
        decision: Wi(n) && this._accumulate(n) < this._upperBound ? Pe.RECORD_AND_SAMPLED : Pe.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var n = 0, r = 0; r < t.length / 8; r++) {
        var i = r * 8, o = parseInt(t.slice(i, i + 8), 16);
        n = (n ^ o) >>> 0;
      }
      return n;
    }, e;
  }()
), yl = Q.AlwaysOn, Le = 1;
function Ro() {
  var e = xe();
  return {
    sampler: No(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function No(e) {
  switch (e === void 0 && (e = xe()), e.OTEL_TRACES_SAMPLER) {
    case Q.AlwaysOn:
      return new Ce();
    case Q.AlwaysOff:
      return new Pt();
    case Q.ParentBasedAlwaysOn:
      return new dn({
        root: new Ce()
      });
    case Q.ParentBasedAlwaysOff:
      return new dn({
        root: new Pt()
      });
    case Q.TraceIdRatio:
      return new $r(Xr(e));
    case Q.ParentBasedTraceIdRatio:
      return new dn({
        root: new $r(Xr(e))
      });
    default:
      return v.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + yl + '".'), new Ce();
  }
}
function Xr(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return v.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Le + "."), Le;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Le + "."), Le) : t < 0 || t > 1 ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Le + "."), Le) : t;
}
function ml(e) {
  var t = {
    sampler: No()
  }, n = Ro(), r = Object.assign({}, n, t, e);
  return r.generalLimits = Object.assign({}, n.generalLimits, e.generalLimits || {}), r.spanLimits = Object.assign({}, n.spanLimits, e.spanLimits || {}), r;
}
function vl(e) {
  var t, n, r, i, o, a, u, c, s, l, f, d, h = Object.assign({}, e.spanLimits), g = Mu();
  return h.attributeCountLimit = (a = (o = (i = (n = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && n !== void 0 ? n : (r = e.generalLimits) === null || r === void 0 ? void 0 : r.attributeCountLimit) !== null && i !== void 0 ? i : g.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : g.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : bt, h.attributeValueLengthLimit = (d = (f = (l = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : g.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : g.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : wt, Object.assign({}, e, { spanLimits: h });
}
var El = (
  /** @class */
  function() {
    function e(t, n) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var r = xe();
      this._maxExportBatchSize = typeof (n == null ? void 0 : n.maxExportBatchSize) == "number" ? n.maxExportBatchSize : r.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (n == null ? void 0 : n.maxQueueSize) == "number" ? n.maxQueueSize : r.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (n == null ? void 0 : n.scheduledDelayMillis) == "number" ? n.scheduledDelayMillis : r.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (n == null ? void 0 : n.exportTimeoutMillis) == "number" ? n.exportTimeoutMillis : r.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new Kc(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (v.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, n) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || t.spanContext().traceFlags & ie.SAMPLED && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && v.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (v.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(n, r) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          n();
        }).catch(r);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(n, r) {
        var i = setTimeout(function() {
          r(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        A.with(Qi(A.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === V.SUCCESS ? n() : r((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(f) {
            de(f), r(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var n = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(r) {
            t._isExporting = !1, de(r);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return n();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return n();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Tl = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Lo = (
  /** @class */
  function(e) {
    Tl(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      return i.onInit(r), i;
    }
    return t.prototype.onInit = function(n) {
      var r = this;
      (n == null ? void 0 : n.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && r.forceFlush().catch(function(i) {
          de(i);
        });
      }, this._pageHideListener = function() {
        r.forceFlush().catch(function(i) {
          de(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(El)
), Sl = 8, wl = 16, bl = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = zr(wl), this.generateSpanId = zr(Sl);
    }
    return e;
  }()
), ht = Array(32);
function zr(e) {
  return function() {
    for (var n = 0; n < e * 2; n++)
      ht[n] = Math.floor(Math.random() * 16) + 48, ht[n] >= 58 && (ht[n] += 39);
    return String.fromCharCode.apply(null, ht.slice(0, e * 2));
  };
}
var Ol = (
  /** @class */
  function() {
    function e(t, n, r) {
      this._tracerProvider = r;
      var i = ml(n);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = n.idGenerator || new bl(), this.resource = r.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, n, r) {
      var i, o, a;
      n === void 0 && (n = {}), r === void 0 && (r = A.active()), n.root && (r = L.deleteSpan(r));
      var u = L.getSpan(r);
      if (hr(r)) {
        v.debug("Instrumentation suppressed, returning Noop Span");
        var c = L.wrapSpanContext(zi);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), l = this._idGenerator.generateSpanId(), f, d, h;
      !s || !L.isSpanContextValid(s) ? f = this._idGenerator.generateTraceId() : (f = s.traceId, d = s.traceState, h = s.spanId);
      var g = (i = n.kind) !== null && i !== void 0 ? i : et.INTERNAL, p = ((o = n.links) !== null && o !== void 0 ? o : []).map(function(U) {
        return {
          context: U.context,
          attributes: St(U.attributes)
        };
      }), m = St(n.attributes), y = this._sampler.shouldSample(r, f, t, g, m, p);
      d = (a = y.traceState) !== null && a !== void 0 ? a : d;
      var T = y.decision === Lt.RECORD_AND_SAMPLED ? ie.SAMPLED : ie.NONE, R = { traceId: f, spanId: l, traceFlags: T, traceState: d };
      if (y.decision === Lt.NOT_RECORD) {
        v.debug("Recording is off, propagating context in a non-recording span");
        var c = L.wrapSpanContext(R);
        return c;
      }
      var x = St(Object.assign(m, y.attributes)), G = new gl(this, r, t, R, g, h, p, n.startTime, void 0, x);
      return G;
    }, e.prototype.startActiveSpan = function(t, n, r, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = n : arguments.length === 3 ? (o = n, u = r) : (o = n, a = r, u = i);
        var c = a != null ? a : A.active(), s = this.startSpan(t, o, c), l = L.setSpan(c, s);
        return A.with(l, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
);
function Al() {
  return "unknown_service";
}
var ce = function() {
  return ce = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ce.apply(this, arguments);
}, Rl = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, Nl = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ll = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, tt = (
  /** @class */
  function() {
    function e(t, n) {
      var r = this, i;
      this._attributes = t, this.asyncAttributesPending = n != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = n == null ? void 0 : n.then(function(o) {
        return r._attributes = Object.assign({}, r._attributes, o), r.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), r.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[oc] = Al(), t[Un] = cn[Un], t[Dn] = cn[Dn], t[Bn] = cn[Bn], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Rl(this, void 0, void 0, function() {
        return Nl(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var n = this, r;
      if (!t)
        return this;
      var i = ce(ce({}, this._syncAttributes), (r = t._syncAttributes) !== null && r !== void 0 ? r : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = Ll(a, 2), s = c[0], l = c[1];
        return ce(ce(ce(ce({}, n._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), pt = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qr = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, n, r = [];
      try {
        for (var i = pt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          r.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(r).then(function() {
          u();
        }).catch(function(c) {
          de(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, n) {
      var r, i;
      try {
        for (var o = pt(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, n);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var n, r;
      try {
        for (var i = pt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, n, r = [];
      try {
        for (var i = pt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          r.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(r).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), Il = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, n) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), Cl = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, xl = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ge;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(ge || (ge = {}));
var Pl = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var n, r;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = Xc({}, Ro(), vl(t));
      if (this.resource = (n = i.resource) !== null && n !== void 0 ? n : tt.empty(), i.mergeResourceWithDefaults && (this.resource = tt.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((r = t.spanProcessors) === null || r === void 0) && r.length)
        this._registeredSpanProcessors = xl([], Cl(t.spanProcessors), !1), this.activeSpanProcessor = new qr(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new Lo(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new Il();
      }
    }
    return e.prototype.getTracer = function(t, n, r) {
      var i = t + "@" + (n || "") + ":" + ((r == null ? void 0 : r.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new Ol({ name: t, version: n, schemaUrl: r == null ? void 0 : r.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(n) {
        return v.error("Error while trying to shutdown current span processor", n);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new qr(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), L.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && A.setGlobalContextManager(t.contextManager), t.propagator && X.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, n = this._registeredSpanProcessors.map(function(r) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = ge.timeout;
          }, t);
          r.forceFlush().then(function() {
            clearTimeout(a), o !== ge.timeout && (o = ge.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = ge.error, i(u);
          });
        });
      });
      return new Promise(function(r, i) {
        Promise.all(n).then(function(o) {
          var a = o.filter(function(u) {
            return u !== ge.resolved;
          });
          a.length > 0 ? i(a) : r();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var n;
      return (n = this.constructor._registeredPropagators.get(t)) === null || n === void 0 ? void 0 : n();
    }, e.prototype._getSpanExporter = function(t) {
      var n;
      return (n = this.constructor._registeredExporters.get(t)) === null || n === void 0 ? void 0 : n();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, n = Array.from(new Set(xe().OTEL_PROPAGATORS)), r = n.map(function(o) {
        var a = t._getPropagator(o);
        return a || v.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = r.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return n.length === 1 ? i[0] : new fo({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = xe().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var n = this._getSpanExporter(t);
        return n || v.error('Exporter "' + t + '" requested through environment variable is unavailable.'), n;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new ho();
      }],
      ["baggage", function() {
        return new Zi();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), Ml = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, kl = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Io = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = pe;
    }
    return e.prototype._bindFunction = function(t, n) {
      t === void 0 && (t = pe);
      var r = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return r.with(t, function() {
          return n.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: n.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, n) {
      return t === void 0 && (t = this.active()), typeof n == "function" ? this._bindFunction(t, n) : n;
    }, e.prototype.disable = function() {
      return this._currentContext = pe, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = pe, this);
    }, e.prototype.with = function(t, n, r) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || pe;
      try {
        return n.call.apply(n, kl([r], Ml(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), Dl = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ul = (
  /** @class */
  function(e) {
    Dl(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, n) || this;
      if (n.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (n.propagator)
        throw "propagator should be defined in register method not in constructor";
      return r;
    }
    return t.prototype.register = function(n) {
      n === void 0 && (n = {}), n.contextManager === void 0 && (n.contextManager = new Io()), n.contextManager && n.contextManager.enable(), e.prototype.register.call(this, n);
    }, t;
  }(Pl)
), S;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(S || (S = {}));
var hn;
function Bl() {
  return hn || (hn = document.createElement("a")), hn;
}
function he(e, t) {
  return t in e;
}
function k(e, t, n, r) {
  var i = void 0, o = void 0;
  he(n, t) && typeof n[t] == "number" && (i = n[t]);
  var a = S.FETCH_START;
  if (he(n, a) && typeof n[a] == "number" && (o = n[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function Me(e, t, n) {
  n === void 0 && (n = !1), n || (k(e, S.FETCH_START, t), k(e, S.DOMAIN_LOOKUP_START, t), k(e, S.DOMAIN_LOOKUP_END, t), k(e, S.CONNECT_START, t), he(t, "name") && t.name.startsWith("https:") && k(e, S.SECURE_CONNECTION_START, t), k(e, S.CONNECT_END, t), k(e, S.REQUEST_START, t), k(e, S.RESPONSE_START, t), k(e, S.RESPONSE_END, t));
  var r = t[S.ENCODED_BODY_SIZE];
  r !== void 0 && e.setAttribute(Yu, r);
  var i = t[S.DECODED_BODY_SIZE];
  i !== void 0 && r !== i && e.setAttribute(Ju, i);
}
function Hl(e) {
  return e.slice().sort(function(t, n) {
    var r = t[S.FETCH_START], i = n[S.FETCH_START];
    return r > i ? 1 : r < i ? -1 : 0;
  });
}
function Co() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function xo(e, t, n, r, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = ne(e);
  e = a.toString();
  var u = Gl(e, t, n, r, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = Hl(u);
  if (a.origin !== Co() && c.length > 1) {
    var s = c[0], l = Fl(c, s[S.RESPONSE_END], n), f = s[S.RESPONSE_END], d = l[S.FETCH_START];
    return d < f && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function Fl(e, t, n) {
  for (var r = re(n), i = re(Ye(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], l = re(Ye(s[S.FETCH_START])), f = re(Ye(s[S.RESPONSE_END])), d = r - f;
    l >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function Gl(e, t, n, r, i, o) {
  var a = re(t), u = re(n), c = r.filter(function(s) {
    var l = re(Ye(s[S.FETCH_START])), f = re(Ye(s[S.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && l >= a && f <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function ne(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = Bl();
  return t.href = e, t;
}
function Po(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var n = jl(e, t);
  if (t && n.indexOf("@id") > 0)
    return n;
  var r = "";
  return e.parentNode && (r += Po(e.parentNode, !1)), r += n, r;
}
function Vl(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var n = Array.from(e.parentNode.childNodes);
  return n = n.filter(function(r) {
    var i = r.localName;
    return t.indexOf(r.nodeType) >= 0 && i === e.localName;
  }), n.length >= 1 ? n.indexOf(e) + 1 : 0;
}
function jl(e, t) {
  var n = e.nodeType, r = Vl(e), i = "";
  if (n === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (n === Node.TEXT_NODE || n === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (n === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && r > 1 ? "/" + i + "[" + r + "]" : "/" + i;
}
function Mo(e, t) {
  var n = t || [];
  (typeof n == "string" || n instanceof RegExp) && (n = [n]);
  var r = ne(e);
  return r.origin === Co() ? !0 : n.some(function(i) {
    return Eo(e, i);
  });
}
var Je;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(Je || (Je = {}));
var $l = "0.44.0", Xl = "@opentelemetry/instrumentation-document-load", Mt;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(Mt || (Mt = {}));
var zl = function() {
  var e, t, n = {}, r = (t = (e = q).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (r) {
    var i = Object.values(S);
    i.forEach(function(u) {
      if (he(r, u)) {
        var c = r[u];
        typeof c == "number" && (n[u] = c);
      }
    });
  } else {
    var o = q, a = o.timing;
    if (a) {
      var i = Object.values(S);
      i.forEach(function(c) {
        if (he(a, c)) {
          var s = a[c];
          typeof s == "number" && (n[c] = s);
        }
      });
    }
  }
  return n;
}, Wr = {
  "first-paint": Mt.FIRST_PAINT,
  "first-contentful-paint": Mt.FIRST_CONTENTFUL_PAINT
}, ql = function(e) {
  var t, n, r = (n = (t = q).getEntriesByType) === null || n === void 0 ? void 0 : n.call(t, "paint");
  r && r.forEach(function(i) {
    var o = i.name, a = i.startTime;
    he(Wr, o) && e.addEvent(Wr[o], a);
  });
}, Wl = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Yl = (
  /** @class */
  function(e) {
    Wl(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, Xl, $l, n) || this;
      return r.component = "document-load", r.version = "1", r.moduleName = r.component, r;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var n = this;
      window.setTimeout(function() {
        n._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(n) {
      var r = this, i, o, a = (o = (i = q).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        r._initResourceSpan(u, n);
      });
    }, t.prototype._collectPerformance = function() {
      var n = this, r = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Ot;
      }), i = zl(), o = r && r.content || "";
      A.with(X.extract(pe, { traceparent: o }), function() {
        var a, u = n._startSpan(Je.DOCUMENT_LOAD, S.FETCH_START, i);
        u && (A.with(L.setSpan(A.active(), u), function() {
          var c = n._startSpan(Je.DOCUMENT_FETCH, S.FETCH_START, i);
          c && (c.setAttribute(We, location.href), A.with(L.setSpan(A.active(), c), function() {
            var s;
            n.getConfig().ignoreNetworkEvents || Me(c, i), n._addCustomAttributesOnSpan(c, (s = n.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), n._endSpan(c, S.RESPONSE_END, i);
          }));
        }), u.setAttribute(We, location.href), u.setAttribute(_r, navigator.userAgent), n._addResourcesSpans(u), n.getConfig().ignoreNetworkEvents || (k(u, S.FETCH_START, i), k(u, S.UNLOAD_EVENT_START, i), k(u, S.UNLOAD_EVENT_END, i), k(u, S.DOM_INTERACTIVE, i), k(u, S.DOM_CONTENT_LOADED_EVENT_START, i), k(u, S.DOM_CONTENT_LOADED_EVENT_END, i), k(u, S.DOM_COMPLETE, i), k(u, S.LOAD_EVENT_START, i), k(u, S.LOAD_EVENT_END, i)), n.getConfig().ignorePerformancePaintEvents || ql(u), n._addCustomAttributesOnSpan(u, (a = n.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), n._endSpan(u, S.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(n, r, i) {
      n && (he(i, r) ? n.end(i[r]) : n.end());
    }, t.prototype._initResourceSpan = function(n, r) {
      var i, o = this._startSpan(Je.RESOURCE_FETCH, S.FETCH_START, n, r);
      o && (o.setAttribute(We, n.name), this.getConfig().ignoreNetworkEvents || Me(o, n), this._addCustomAttributesOnResourceSpan(o, n, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, S.RESPONSE_END, n));
    }, t.prototype._startSpan = function(n, r, i, o) {
      if (he(i, r) && typeof i[r] == "number") {
        var a = this.tracer.startSpan(n, {
          startTime: i[r]
        }, o ? L.setSpan(A.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(n, r) {
      var i = this;
      r && xt(function() {
        return r(n);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(n, r, i) {
      var o = this;
      i && xt(function() {
        return i(n, r);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(Vt)
), kt;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(kt || (kt = {}));
var Jl = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, Kl = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ql = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Zl = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ko = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function ef() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var n = e[1];
    if (!(n != null && n.body))
      return Promise.resolve();
    if (n.body instanceof ReadableStream) {
      var r = tf(n.body), i = r.body, o = r.length;
      return n.body = i, o;
    } else
      return Promise.resolve(nf(n.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return jn(u);
    }) : Promise.resolve();
  }
}
function tf(e) {
  if (!e.pipeThrough)
    return ko.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, n, r = new Promise(function(o) {
    n = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return Jl(this, void 0, void 0, function() {
        var u;
        return Kl(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      n(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: r
  };
}
function nf(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return of(e);
  if (e instanceof URLSearchParams)
    return jn(e.toString());
  if (typeof e == "string")
    return jn(e);
  ko.warn("unknown body type");
}
var rf = new TextEncoder();
function jn(e) {
  return rf.encode(e).byteLength;
}
function of(e) {
  var t, n, r = 0;
  try {
    for (var i = Ql(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Zl(o.value, 2), u = a[0], c = a[1];
      r += u.length, c instanceof Blob ? r += c.size : r += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
var Yr = "0.57.1", af = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), sf = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, uf = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, pn, cf = 300, Jr = typeof process == "object" && ((pn = process.release) === null || pn === void 0 ? void 0 : pn.name) === "node", lf = (
  /** @class */
  function(e) {
    af(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, "@opentelemetry/instrumentation-fetch", Yr, n) || this;
      return r.component = "fetch", r.version = Yr, r.moduleName = r.component, r._usedResources = /* @__PURE__ */ new WeakSet(), r._tasksCount = 0, r;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(n, r) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: r[S.FETCH_START]
      }, L.setSpan(A.active(), n));
      Me(i, r, this.getConfig().ignoreNetworkEvents), i.end(r[S.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(n, r) {
      var i = ne(r.url);
      n.setAttribute(uo, r.status), r.statusText != null && n.setAttribute(kt.HTTP_STATUS_TEXT, r.statusText), n.setAttribute(ao, i.host), n.setAttribute(so, i.protocol.replace(":", "")), typeof navigator != "undefined" && n.setAttribute(_r, navigator.userAgent);
    }, t.prototype._addHeaders = function(n, r) {
      if (!Mo(r, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        X.inject(A.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (n instanceof Request)
        X.inject(A.active(), n.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (n.headers instanceof Headers)
        X.inject(A.active(), n.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (n.headers instanceof Map)
        X.inject(A.active(), n.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        X.inject(A.active(), i), n.headers = Object.assign({}, i, n.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(n, r) {
      var i;
      if (r === void 0 && (r = {}), To(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (r.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: et.CLIENT,
        attributes: (i = {}, i[kt.COMPONENT] = this.moduleName, i[oo] = o, i[We] = n, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(n, r, i) {
      var o = r.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = xo(r.spanUrl, r.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(n, c), this._markResourceAsUsed(c)), Me(n, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(n) {
      this._usedResources.add(n);
    }, t.prototype._endSpan = function(n, r, i) {
      var o = this, a = z(Date.now()), u = Ee();
      this._addFinalSpanAttributes(n, i), setTimeout(function() {
        var c;
        (c = r.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(n, r, u), o._tasksCount--, o._clearResources(), n.end(a);
      }, cf);
    }, t.prototype._patchConstructor = function() {
      var n = this;
      return function(r) {
        var i = n;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = ne(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(s, l);
          if (!f)
            return r.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && ef.apply(void 0, uf([], sf(a), !1)).then(function(y) {
            y && f.setAttribute(co, y);
          }).catch(function(y) {
            i._diag.warn("getFetchBodyLength", y);
          });
          function h(y, T) {
            i._applyAttributesAfterFetch(y, l, T), i._endSpan(y, d, {
              status: T.status || 0,
              statusText: T.message,
              url: s
            });
          }
          function g(y, T) {
            i._applyAttributesAfterFetch(y, l, T), T.status >= 200 && T.status < 400 ? i._endSpan(y, d, T) : i._endSpan(y, d, {
              status: T.status,
              statusText: T.statusText,
              url: s
            });
          }
          function p(y, T, R) {
            try {
              var x = R.clone(), G = R.clone(), U = x.body;
              if (U) {
                var ae = U.getReader(), J = function() {
                  ae.read().then(function(se) {
                    var ut = se.done;
                    ut ? g(y, G) : J();
                  }, function(se) {
                    h(y, se);
                  });
                };
                J();
              } else
                g(y, R);
            } finally {
              T(R);
            }
          }
          function m(y, T, R) {
            try {
              h(y, R);
            } finally {
              T(R);
            }
          }
          return new Promise(function(y, T) {
            return A.with(L.setSpan(A.active(), f), function() {
              return i._addHeaders(l, s), i._tasksCount++, r.apply(c, l instanceof Request ? [l] : [s, l]).then(p.bind(c, f, y), m.bind(c, f, T));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(n, r, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && xt(function() {
        return a(n, r, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(n) {
      var r = Ee(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: r, spanUrl: n };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === n && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: r, spanUrl: n };
    }, t.prototype.enable = function() {
      if (Jr) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      M(fetch) && (this._unwrap(qe, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(qe, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      Jr || (this._unwrap(qe, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(Vt)
), te;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(te || (te = {}));
var ff = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, df = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, hf = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function pf(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return gf(e);
  if (e instanceof URLSearchParams)
    return Kr(e.toString());
  if (typeof e == "string")
    return Kr(e);
  hf.warn("unknown body type");
}
var _f = new TextEncoder();
function Kr(e) {
  return _f.encode(e).byteLength;
}
function gf(e) {
  var t, n, r = 0;
  try {
    for (var i = ff(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = df(o.value, 2), u = a[0], c = a[1];
      r += u.length, c instanceof Blob ? r += c.size : r += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
var Qr = "0.57.1", $n;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})($n || ($n = {}));
var yf = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), mf = 300, vf = (
  /** @class */
  function(e) {
    yf(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, "@opentelemetry/instrumentation-xml-http-request", Qr, n) || this;
      return r.component = "xml-http-request", r.version = Qr, r.moduleName = r.component, r._tasksCount = 0, r._xhrMem = /* @__PURE__ */ new WeakMap(), r._usedResources = /* @__PURE__ */ new WeakSet(), r;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(n, r) {
      var i = ne(r).href;
      if (!Mo(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        X.inject(A.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      X.inject(A.active(), a), Object.keys(a).forEach(function(u) {
        n.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(n, r) {
      var i = this;
      A.with(L.setSpan(A.active(), n), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: r[S.FETCH_START]
        });
        Me(o, r, i.getConfig().ignoreNetworkEvents), o.end(r[S.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(n, r, i) {
      if (typeof i == "string") {
        var o = ne(i);
        r.status !== void 0 && n.setAttribute(uo, r.status), r.statusText !== void 0 && n.setAttribute($n.HTTP_STATUS_TEXT, r.statusText), n.setAttribute(ao, o.host), n.setAttribute(so, o.protocol.replace(":", "")), n.setAttribute(_r, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(n, r) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && xt(function() {
        return o(n, r);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(n, r) {
      var i = this._xhrMem.get(n);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = ne(r);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (q.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(n, r, i, o, a) {
      if (!(!i || !o || !a || !n.createdResources)) {
        var u = n.createdResources.entries;
        (!u || !u.length) && (u = q.getEntriesByType("resource"));
        var c = xo(ne(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(r, l), this._markResourceAsUsed(l)), Me(r, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(n) {
      var r = this._xhrMem.get(n);
      if (r) {
        var i = r.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(n);
      }
    }, t.prototype._createSpan = function(n, r, i) {
      var o;
      if (To(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: et.CLIENT,
        attributes: (o = {}, o[oo] = i, o[We] = ne(r).toString(), o)
      });
      return u.addEvent(te.METHOD_OPEN), this._cleanPreviousSpanInformation(n), this._xhrMem.set(n, {
        span: u,
        spanUrl: r
      }), u;
    }, t.prototype._markResourceAsUsed = function(n) {
      this._usedResources.add(n);
    }, t.prototype._patchOpen = function() {
      var n = this;
      return function(r) {
        var i = n;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), r.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var n = this;
      function r(l, f, d, h) {
        var g = f.callbackToRemoveEvents;
        typeof g == "function" && g();
        var p = f.span, m = f.spanUrl, y = f.sendStartTime;
        p && (n._findResourceAndAddNetworkEvents(f, p, m, y, d), p.addEvent(l, h), n._addFinalSpanAttributes(p, f, m), p.end(h), n._tasksCount--), n._clearResources();
      }
      function i(l, f) {
        var d = n._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, n._xhrMem.delete(f), d.span && n._applyAttributesAfterXHR(d.span, f);
          var h = Ee(), g = Date.now();
          setTimeout(function() {
            r(l, d, h, g);
          }, mf);
        }
      }
      function o() {
        i(te.EVENT_ERROR, this);
      }
      function a() {
        i(te.EVENT_ABORT, this);
      }
      function u() {
        i(te.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(te.EVENT_LOAD, this) : i(te.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var f = n._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, h = [], g = 0; g < arguments.length; g++)
            h[g] = arguments[g];
          var p = n._xhrMem.get(this);
          if (!p)
            return l.apply(this, h);
          var m = p.span, y = p.spanUrl;
          if (m && y) {
            if (n.getConfig().measureRequestSize && (h != null && h[0])) {
              var T = h[0], R = pf(T);
              R !== void 0 && m.setAttribute(co, R);
            }
            A.with(L.setSpan(A.active(), m), function() {
              n._tasksCount++, p.sendStartTime = Ee(), m.addEvent(te.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), p.callbackToRemoveEvents = function() {
                s(d), p.createdResources && p.createdResources.observer.disconnect();
              }, n._addHeaders(d, y), n._addResourceObserver(d, y);
            });
          }
          return l.apply(this, h);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), M(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), M(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(Vt)
);
function _n(e, t) {
  if (!!!e)
    throw new Error(t);
}
function Ef(e) {
  return typeof e == "object" && e !== null;
}
function Tf(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const Sf = /\r\n|[\n\r]/g;
function Xn(e, t) {
  let n = 0, r = 1;
  for (const i of e.body.matchAll(Sf)) {
    if (typeof i.index == "number" || Tf(!1), i.index >= t)
      break;
    n = i.index + i[0].length, r += 1;
  }
  return {
    line: r,
    column: t + 1 - n
  };
}
function wf(e) {
  return Do(
    e.source,
    Xn(e.source, e.start)
  );
}
function Do(e, t) {
  const n = e.locationOffset.column - 1, r = "".padStart(n) + e.body, i = t.line - 1, o = e.locationOffset.line - 1, a = t.line + o, u = t.line === 1 ? n : 0, c = t.column + u, s = `${e.name}:${a}:${c}
`, l = r.split(/\r\n|[\n\r]/g), f = l[i];
  if (f.length > 120) {
    const d = Math.floor(c / 80), h = c % 80, g = [];
    for (let p = 0; p < f.length; p += 80)
      g.push(f.slice(p, p + 80));
    return s + Zr([
      [`${a} |`, g[0]],
      ...g.slice(1, d + 1).map((p) => ["|", p]),
      ["|", "^".padStart(h)],
      ["|", g[d + 1]]
    ]);
  }
  return s + Zr([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, l[i - 1]],
    [`${a} |`, f],
    ["|", "^".padStart(c)],
    [`${a + 1} |`, l[i + 1]]
  ]);
}
function Zr(e) {
  const t = e.filter(([r, i]) => i !== void 0), n = Math.max(...t.map(([r]) => r.length));
  return t.map(([r, i]) => r.padStart(n) + (i ? " " + i : "")).join(`
`);
}
function bf(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class mr extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...n) {
    var r, i, o;
    const { nodes: a, source: u, positions: c, path: s, originalError: l, extensions: f } = bf(n);
    super(t), this.name = "GraphQLError", this.path = s != null ? s : void 0, this.originalError = l != null ? l : void 0, this.nodes = ei(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const d = ei(
      (r = this.nodes) === null || r === void 0 ? void 0 : r.map((g) => g.loc).filter((g) => g != null)
    );
    this.source = u != null ? u : d == null || (i = d[0]) === null || i === void 0 ? void 0 : i.source, this.positions = c != null ? c : d == null ? void 0 : d.map((g) => g.start), this.locations = c && u ? c.map((g) => Xn(u, g)) : d == null ? void 0 : d.map((g) => Xn(g.source, g.start));
    const h = Ef(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (o = f != null ? f : h) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, mr) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const n of this.nodes)
        n.loc && (t += `

` + wf(n.loc));
    else if (this.source && this.locations)
      for (const n of this.locations)
        t += `

` + Do(this.source, n);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function ei(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function D(e, t, n) {
  return new mr(`Syntax Error: ${n}`, {
    source: e,
    positions: [t]
  });
}
class Of {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, n, r) {
    this.start = t.start, this.end = n.end, this.startToken = t, this.endToken = n, this.source = r;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Uo {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, n, r, i, o, a) {
    this.kind = t, this.start = n, this.end = r, this.line = i, this.column = o, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Af = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Rf = new Set(Object.keys(Af));
function J_(e) {
  const t = e == null ? void 0 : e.kind;
  return typeof t == "string" && Rf.has(t);
}
var Ie;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Ie || (Ie = {}));
var zn;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(zn || (zn = {}));
var E;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(E || (E = {}));
function qn(e) {
  return e === 9 || e === 32;
}
function nt(e) {
  return e >= 48 && e <= 57;
}
function Bo(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Ho(e) {
  return Bo(e) || e === 95;
}
function Nf(e) {
  return Bo(e) || nt(e) || e === 95;
}
function Lf(e) {
  var t;
  let n = Number.MAX_SAFE_INTEGER, r = null, i = -1;
  for (let a = 0; a < e.length; ++a) {
    var o;
    const u = e[a], c = If(u);
    c !== u.length && (r = (o = r) !== null && o !== void 0 ? o : a, i = a, a !== 0 && c < n && (n = c));
  }
  return e.map((a, u) => u === 0 ? a : a.slice(n)).slice(
    (t = r) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function If(e) {
  let t = 0;
  for (; t < e.length && qn(e.charCodeAt(t)); )
    ++t;
  return t;
}
function K_(e, t) {
  const n = e.replace(/"""/g, '\\"""'), r = n.split(/\r\n|[\n\r]/g), i = r.length === 1, o = r.length > 1 && r.slice(1).every((h) => h.length === 0 || qn(h.charCodeAt(0))), a = n.endsWith('\\"""'), u = e.endsWith('"') && !a, c = e.endsWith("\\"), s = u || c, l = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || s || o || a
  );
  let f = "";
  const d = i && qn(e.charCodeAt(0));
  return (l && !d || o) && (f += `
`), f += n, (l || s) && (f += `
`), '"""' + f + '"""';
}
var _;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(_ || (_ = {}));
class Cf {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const n = new Uo(_.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== _.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const n = Pf(this, t.end);
          t.next = n, n.prev = t, t = n;
        }
      while (t.kind === _.COMMENT);
    return t;
  }
}
function xf(e) {
  return e === _.BANG || e === _.DOLLAR || e === _.AMP || e === _.PAREN_L || e === _.PAREN_R || e === _.SPREAD || e === _.COLON || e === _.EQUALS || e === _.AT || e === _.BRACKET_L || e === _.BRACKET_R || e === _.BRACE_L || e === _.PIPE || e === _.BRACE_R;
}
function De(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function jt(e, t) {
  return Fo(e.charCodeAt(t)) && Go(e.charCodeAt(t + 1));
}
function Fo(e) {
  return e >= 55296 && e <= 56319;
}
function Go(e) {
  return e >= 56320 && e <= 57343;
}
function Te(e, t) {
  const n = e.source.body.codePointAt(t);
  if (n === void 0)
    return _.EOF;
  if (n >= 32 && n <= 126) {
    const r = String.fromCodePoint(n);
    return r === '"' ? `'"'` : `"${r}"`;
  }
  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}
function C(e, t, n, r, i) {
  const o = e.line, a = 1 + n - e.lineStart;
  return new Uo(t, n, r, o, a, i);
}
function Pf(e, t) {
  const n = e.source.body, r = n.length;
  let i = t;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        n.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return Mf(e, i);
      case 33:
        return C(e, _.BANG, i, i + 1);
      case 36:
        return C(e, _.DOLLAR, i, i + 1);
      case 38:
        return C(e, _.AMP, i, i + 1);
      case 40:
        return C(e, _.PAREN_L, i, i + 1);
      case 41:
        return C(e, _.PAREN_R, i, i + 1);
      case 46:
        if (n.charCodeAt(i + 1) === 46 && n.charCodeAt(i + 2) === 46)
          return C(e, _.SPREAD, i, i + 3);
        break;
      case 58:
        return C(e, _.COLON, i, i + 1);
      case 61:
        return C(e, _.EQUALS, i, i + 1);
      case 64:
        return C(e, _.AT, i, i + 1);
      case 91:
        return C(e, _.BRACKET_L, i, i + 1);
      case 93:
        return C(e, _.BRACKET_R, i, i + 1);
      case 123:
        return C(e, _.BRACE_L, i, i + 1);
      case 124:
        return C(e, _.PIPE, i, i + 1);
      case 125:
        return C(e, _.BRACE_R, i, i + 1);
      case 34:
        return n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34 ? Ff(e, i) : Df(e, i);
    }
    if (nt(o) || o === 45)
      return kf(e, i, o);
    if (Ho(o))
      return Gf(e, i);
    throw D(
      e.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : De(o) || jt(n, i) ? `Unexpected character: ${Te(e, i)}.` : `Invalid character: ${Te(e, i)}.`
    );
  }
  return C(e, _.EOF, r, r);
}
function Mf(e, t) {
  const n = e.source.body, r = n.length;
  let i = t + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (De(o))
      ++i;
    else if (jt(n, i))
      i += 2;
    else
      break;
  }
  return C(
    e,
    _.COMMENT,
    t,
    i,
    n.slice(t + 1, i)
  );
}
function kf(e, t, n) {
  const r = e.source.body;
  let i = t, o = n, a = !1;
  if (o === 45 && (o = r.charCodeAt(++i)), o === 48) {
    if (o = r.charCodeAt(++i), nt(o))
      throw D(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${Te(
          e,
          i
        )}.`
      );
  } else
    i = gn(e, i, o), o = r.charCodeAt(i);
  if (o === 46 && (a = !0, o = r.charCodeAt(++i), i = gn(e, i, o), o = r.charCodeAt(i)), (o === 69 || o === 101) && (a = !0, o = r.charCodeAt(++i), (o === 43 || o === 45) && (o = r.charCodeAt(++i)), i = gn(e, i, o), o = r.charCodeAt(i)), o === 46 || Ho(o))
    throw D(
      e.source,
      i,
      `Invalid number, expected digit but got: ${Te(
        e,
        i
      )}.`
    );
  return C(
    e,
    a ? _.FLOAT : _.INT,
    t,
    i,
    r.slice(t, i)
  );
}
function gn(e, t, n) {
  if (!nt(n))
    throw D(
      e.source,
      t,
      `Invalid number, expected digit but got: ${Te(
        e,
        t
      )}.`
    );
  const r = e.source.body;
  let i = t + 1;
  for (; nt(r.charCodeAt(i)); )
    ++i;
  return i;
}
function Df(e, t) {
  const n = e.source.body, r = n.length;
  let i = t + 1, o = i, a = "";
  for (; i < r; ) {
    const u = n.charCodeAt(i);
    if (u === 34)
      return a += n.slice(o, i), C(e, _.STRING, t, i + 1, a);
    if (u === 92) {
      a += n.slice(o, i);
      const c = n.charCodeAt(i + 1) === 117 ? n.charCodeAt(i + 2) === 123 ? Uf(e, i) : Bf(e, i) : Hf(e, i);
      a += c.value, i += c.size, o = i;
      continue;
    }
    if (u === 10 || u === 13)
      break;
    if (De(u))
      ++i;
    else if (jt(n, i))
      i += 2;
    else
      throw D(
        e.source,
        i,
        `Invalid character within String: ${Te(
          e,
          i
        )}.`
      );
  }
  throw D(e.source, i, "Unterminated string.");
}
function Uf(e, t) {
  const n = e.source.body;
  let r = 0, i = 3;
  for (; i < 12; ) {
    const o = n.charCodeAt(t + i++);
    if (o === 125) {
      if (i < 5 || !De(r))
        break;
      return {
        value: String.fromCodePoint(r),
        size: i
      };
    }
    if (r = r << 4 | je(o), r < 0)
      break;
  }
  throw D(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(
      t,
      t + i
    )}".`
  );
}
function Bf(e, t) {
  const n = e.source.body, r = ti(n, t + 2);
  if (De(r))
    return {
      value: String.fromCodePoint(r),
      size: 6
    };
  if (Fo(r) && n.charCodeAt(t + 6) === 92 && n.charCodeAt(t + 7) === 117) {
    const i = ti(n, t + 8);
    if (Go(i))
      return {
        value: String.fromCodePoint(r, i),
        size: 12
      };
  }
  throw D(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(t, t + 6)}".`
  );
}
function ti(e, t) {
  return je(e.charCodeAt(t)) << 12 | je(e.charCodeAt(t + 1)) << 8 | je(e.charCodeAt(t + 2)) << 4 | je(e.charCodeAt(t + 3));
}
function je(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function Hf(e, t) {
  const n = e.source.body;
  switch (n.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw D(
    e.source,
    t,
    `Invalid character escape sequence: "${n.slice(
      t,
      t + 2
    )}".`
  );
}
function Ff(e, t) {
  const n = e.source.body, r = n.length;
  let i = e.lineStart, o = t + 3, a = o, u = "";
  const c = [];
  for (; o < r; ) {
    const s = n.charCodeAt(o);
    if (s === 34 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34) {
      u += n.slice(a, o), c.push(u);
      const l = C(
        e,
        _.BLOCK_STRING,
        t,
        o + 3,
        // Return a string of the lines joined with U+000A.
        Lf(c).join(`
`)
      );
      return e.line += c.length - 1, e.lineStart = i, l;
    }
    if (s === 92 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34 && n.charCodeAt(o + 3) === 34) {
      u += n.slice(a, o), a = o + 1, o += 4;
      continue;
    }
    if (s === 10 || s === 13) {
      u += n.slice(a, o), c.push(u), s === 13 && n.charCodeAt(o + 1) === 10 ? o += 2 : ++o, u = "", a = o, i = o;
      continue;
    }
    if (De(s))
      ++o;
    else if (jt(n, o))
      o += 2;
    else
      throw D(
        e.source,
        o,
        `Invalid character within String: ${Te(
          e,
          o
        )}.`
      );
  }
  throw D(e.source, o, "Unterminated string.");
}
function Gf(e, t) {
  const n = e.source.body, r = n.length;
  let i = t + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (Nf(o))
      ++i;
    else
      break;
  }
  return C(
    e,
    _.NAME,
    t,
    i,
    n.slice(t, i)
  );
}
const Vf = 10, Vo = 2;
function jo(e) {
  return $t(e, []);
}
function $t(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return jf(e, t);
    default:
      return String(e);
  }
}
function jf(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const n = [...t, e];
  if ($f(e)) {
    const r = e.toJSON();
    if (r !== e)
      return typeof r == "string" ? r : $t(r, n);
  } else if (Array.isArray(e))
    return zf(e, n);
  return Xf(e, n);
}
function $f(e) {
  return typeof e.toJSON == "function";
}
function Xf(e, t) {
  const n = Object.entries(e);
  return n.length === 0 ? "{}" : t.length > Vo ? "[" + qf(e) + "]" : "{ " + n.map(
    ([i, o]) => i + ": " + $t(o, t)
  ).join(", ") + " }";
}
function zf(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > Vo)
    return "[Array]";
  const n = Math.min(Vf, e.length), r = e.length - n, i = [];
  for (let o = 0; o < n; ++o)
    i.push($t(e[o], t));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push(`... ${r} more items`), "[" + i.join(", ") + "]";
}
function qf(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
const Wf = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(t, n) {
    return t instanceof n;
  } : function(t, n) {
    if (t instanceof n)
      return !0;
    if (typeof t == "object" && t !== null) {
      var r;
      const i = n.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (r = t.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (i === o) {
        const a = jo(t);
        throw new Error(`Cannot use ${i} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class $o {
  constructor(t, n = "GraphQL request", r = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || _n(!1, `Body must be a string. Received: ${jo(t)}.`), this.body = t, this.name = n, this.locationOffset = r, this.locationOffset.line > 0 || _n(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || _n(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function Yf(e) {
  return Wf(e, $o);
}
function Jf(e, t) {
  return new Kf(e, t).parseDocument();
}
class Kf {
  constructor(t, n = {}) {
    const r = Yf(t) ? t : new $o(t);
    this._lexer = new Cf(r), this._options = n, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(_.NAME);
    return this.node(t, {
      kind: E.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: E.DOCUMENT,
      definitions: this.many(
        _.SOF,
        this.parseDefinition,
        _.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(_.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), n = t ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === _.NAME) {
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw D(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (n.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(n);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(_.BRACE_L))
      return this.node(t, {
        kind: E.OPERATION_DEFINITION,
        operation: Ie.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const n = this.parseOperationType();
    let r;
    return this.peek(_.NAME) && (r = this.parseName()), this.node(t, {
      kind: E.OPERATION_DEFINITION,
      operation: n,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(_.NAME);
    switch (t.value) {
      case "query":
        return Ie.QUERY;
      case "mutation":
        return Ie.MUTATION;
      case "subscription":
        return Ie.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      _.PAREN_L,
      this.parseVariableDefinition,
      _.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: E.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(_.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(_.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(_.DOLLAR), this.node(t, {
      kind: E.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: E.SELECTION_SET,
      selections: this.many(
        _.BRACE_L,
        this.parseSelection,
        _.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(_.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, n = this.parseName();
    let r, i;
    return this.expectOptionalToken(_.COLON) ? (r = n, i = this.parseName()) : i = n, this.node(t, {
      kind: E.FIELD,
      alias: r,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(_.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const n = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(_.PAREN_L, n, _.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(_.COLON), this.node(n, {
      kind: E.ARGUMENT,
      name: r,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(_.SPREAD);
    const n = this.expectOptionalKeyword("on");
    return !n && this.peek(_.NAME) ? this.node(t, {
      kind: E.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: E.INLINE_FRAGMENT,
      typeCondition: n ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: E.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: E.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const n = this._lexer.token;
    switch (n.kind) {
      case _.BRACKET_L:
        return this.parseList(t);
      case _.BRACE_L:
        return this.parseObject(t);
      case _.INT:
        return this.advanceLexer(), this.node(n, {
          kind: E.INT,
          value: n.value
        });
      case _.FLOAT:
        return this.advanceLexer(), this.node(n, {
          kind: E.FLOAT,
          value: n.value
        });
      case _.STRING:
      case _.BLOCK_STRING:
        return this.parseStringLiteral();
      case _.NAME:
        switch (this.advanceLexer(), n.value) {
          case "true":
            return this.node(n, {
              kind: E.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(n, {
              kind: E.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(n, {
              kind: E.NULL
            });
          default:
            return this.node(n, {
              kind: E.ENUM,
              value: n.value
            });
        }
      case _.DOLLAR:
        if (t)
          if (this.expectToken(_.DOLLAR), this._lexer.token.kind === _.NAME) {
            const r = this._lexer.token.value;
            throw D(
              this._lexer.source,
              n.start,
              `Unexpected variable "$${r}" in constant value.`
            );
          } else
            throw this.unexpected(n);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: E.STRING,
      value: t.value,
      block: t.kind === _.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const n = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: E.LIST,
      values: this.any(_.BRACKET_L, n, _.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const n = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: E.OBJECT,
      fields: this.any(_.BRACE_L, n, _.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(_.COLON), this.node(n, {
      kind: E.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const n = [];
    for (; this.peek(_.AT); )
      n.push(this.parseDirective(t));
    return n;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const n = this._lexer.token;
    return this.expectToken(_.AT), this.node(n, {
      kind: E.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let n;
    if (this.expectOptionalToken(_.BRACKET_L)) {
      const r = this.parseTypeReference();
      this.expectToken(_.BRACKET_R), n = this.node(t, {
        kind: E.LIST_TYPE,
        type: r
      });
    } else
      n = this.parseNamedType();
    return this.expectOptionalToken(_.BANG) ? this.node(t, {
      kind: E.NON_NULL_TYPE,
      type: n
    }) : n;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: E.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(_.STRING) || this.peek(_.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("schema");
    const r = this.parseConstDirectives(), i = this.many(
      _.BRACE_L,
      this.parseOperationTypeDefinition,
      _.BRACE_R
    );
    return this.node(t, {
      kind: E.SCHEMA_DEFINITION,
      description: n,
      directives: r,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, n = this.parseOperationType();
    this.expectToken(_.COLON);
    const r = this.parseNamedType();
    return this.node(t, {
      kind: E.OPERATION_TYPE_DEFINITION,
      operation: n,
      type: r
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("scalar");
    const r = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: E.SCALAR_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("type");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: E.OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(_.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      _.BRACE_L,
      this.parseFieldDefinition,
      _.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(_.COLON);
    const o = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(t, {
      kind: E.FIELD_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      type: o,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      _.PAREN_L,
      this.parseInputValueDef,
      _.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseName();
    this.expectToken(_.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(_.EQUALS) && (o = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(t, {
      kind: E.INPUT_VALUE_DEFINITION,
      description: n,
      name: r,
      type: i,
      defaultValue: o,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("interface");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: E.INTERFACE_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("union");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: E.UNION_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(_.EQUALS) ? this.delimitedMany(_.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("enum");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: E.ENUM_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      _.BRACE_L,
      this.parseEnumValueDefinition,
      _.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: E.ENUM_VALUE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw D(
        this._lexer.source,
        this._lexer.token.start,
        `${_t(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("input");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: E.INPUT_OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      _.BRACE_L,
      this.parseInputValueDef,
      _.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === _.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const n = this.parseConstDirectives(), r = this.optionalMany(
      _.BRACE_L,
      this.parseOperationTypeDefinition,
      _.BRACE_R
    );
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: E.SCHEMA_EXTENSION,
      directives: n,
      operationTypes: r
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const n = this.parseName(), r = this.parseConstDirectives();
    if (r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: E.SCALAR_TYPE_EXTENSION,
      name: n,
      directives: r
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: E.OBJECT_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: E.INTERFACE_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: E.UNION_TYPE_EXTENSION,
      name: n,
      directives: r,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: E.ENUM_TYPE_EXTENSION,
      name: n,
      directives: r,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: E.INPUT_OBJECT_TYPE_EXTENSION,
      name: n,
      directives: r,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(_.AT);
    const r = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(t, {
      kind: E.DIRECTIVE_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      repeatable: o,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(_.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, n = this.parseName();
    if (Object.prototype.hasOwnProperty.call(zn, n.value))
      return n;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, n) {
    return this._options.noLocation !== !0 && (n.loc = new Of(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), n;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const n = this._lexer.token;
    if (n.kind === t)
      return this.advanceLexer(), n;
    throw D(
      this._lexer.source,
      n.start,
      `Expected ${Xo(t)}, found ${_t(n)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const n = this._lexer.token;
    if (n.kind === _.NAME && n.value === t)
      this.advanceLexer();
    else
      throw D(
        this._lexer.source,
        n.start,
        `Expected "${t}", found ${_t(n)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const n = this._lexer.token;
    return n.kind === _.NAME && n.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const n = t != null ? t : this._lexer.token;
    return D(
      this._lexer.source,
      n.start,
      `Unexpected ${_t(n)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, n, r) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(r); )
      i.push(n.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, n, r) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(n.call(this));
      while (!this.expectOptionalToken(r));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, n, r) {
    this.expectToken(t);
    const i = [];
    do
      i.push(n.call(this));
    while (!this.expectOptionalToken(r));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, n) {
    this.expectOptionalToken(t);
    const r = [];
    do
      r.push(n.call(this));
    while (this.expectOptionalToken(t));
    return r;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, n = this._lexer.advance();
    if (t !== void 0 && n.kind !== _.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw D(
        this._lexer.source,
        n.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function _t(e) {
  const t = e.value;
  return Xo(e.kind) + (t != null ? ` "${t}"` : "");
}
function Xo(e) {
  return xf(e) ? `"${e}"` : e;
}
/*! js-cookie v3.0.5 | MIT */
function gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var Qf = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Wn(e, t) {
  function n(i, o, a) {
    if (typeof document != "undefined") {
      a = gt({}, t, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var u = "";
      for (var c in a)
        a[c] && (u += "; " + c, a[c] !== !0 && (u += "=" + a[c].split(";")[0]));
      return document.cookie = i + "=" + e.write(o, i) + u;
    }
  }
  function r(i) {
    if (!(typeof document == "undefined" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, u = 0; u < o.length; u++) {
        var c = o[u].split("="), s = c.slice(1).join("=");
        try {
          var l = decodeURIComponent(c[0]);
          if (a[l] = e.read(s, l), i === l)
            break;
        } catch (f) {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(i, o) {
        n(
          i,
          "",
          gt({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return Wn(this.converter, gt({}, this.attributes, i));
      },
      withConverter: function(i) {
        return Wn(gt({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var yn = Wn(Qf, { path: "/" });
let vr = "localStorage", Yn = !0;
class Zf {
  constructor() {
    b(this, "storage", {});
  }
  getItem(t) {
    var n;
    return (n = this.storage[t]) != null ? n : "";
  }
  setItem(t, n) {
    this.storage[t] = n;
  }
  removeItem(t) {
    delete this.storage[t];
  }
}
class ed {
  getItem(t) {
    var n;
    return (n = yn.get(t)) != null ? n : "";
  }
  setItem(t, n) {
    if (!Yn)
      return;
    const r = /* @__PURE__ */ new Date();
    r.setTime(r.getTime() + 9e5), yn.set(t, n, { expires: r });
  }
  removeItem(t) {
    Yn && yn.remove(t);
  }
}
let td = new Zf();
const Dt = new ed(), Er = () => {
  try {
    switch (vr) {
      case "localStorage":
        return window.localStorage;
      case "sessionStorage":
        return window.sessionStorage;
    }
  } catch (e) {
    return td;
  }
}, Q_ = (e) => {
  vr = e;
}, nd = (e) => {
  Yn = e;
}, zo = (e) => Er().getItem(e), qo = (e, t) => (Dt.setItem(e, t), Er().setItem(e, t)), rd = (e) => (Dt.removeItem(e), Er().removeItem(e)), Z_ = (e) => {
  if (vr === "sessionStorage") {
    console.warn("highlight.io cannot use local storage; segment integration will not work");
    return;
  }
  const t = window.localStorage.setItem;
  window.localStorage.setItem = function() {
    const [n, r] = arguments;
    e({ keyName: n, keyValue: r }), t.apply(this, [n, r]);
  };
};
var ke;
(function(e) {
  e.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", e.SESSION_ID = "sessionID", e.SESSION_DATA = "sessionData", e.USER_IDENTIFIER = "highlightIdentifier", e.USER_OBJECT = "highlightUserObject";
})(ke || (ke = {}));
const Xt = (e) => `${ke.SESSION_DATA}_${e}`;
let Wo = "";
const id = () => Wo, od = (e) => {
  e && (Wo = e);
}, ad = () => {
  var e;
  return (e = zo(ke.SESSION_ID)) != null ? e : "";
}, sd = (e) => {
  qo(ke.SESSION_ID, e);
}, ud = (e) => {
  const t = Xt(e);
  return JSON.parse(zo(t) || "{}");
}, mn = (e) => {
  e || (e = ad());
  let t = ud(e);
  if (t && t.lastPushTime && Date.now() - t.lastPushTime < 9e5)
    return t;
  rd(Xt(e));
}, cd = function(e) {
  if (!(e != null && e.sessionSecureID))
    return;
  const t = e.sessionSecureID;
  od(t), qo(Xt(t), JSON.stringify(e));
}, ld = function() {
  const e = Dt.getItem(ke.SESSION_ID);
  sd(e);
  const t = Xt(e), n = Dt.getItem(t);
  try {
    cd(JSON.parse(n));
  } catch (r) {
  }
}, ni = (e, t, n) => {
  const r = Yo(t, e.headers, n);
  return H(P({}, e), {
    headers: r
  });
}, Yo = (e, t, n) => {
  var i, o;
  const r = P({}, t);
  return n ? ((i = Object.keys(r)) == null || i.forEach((a) => {
    [...n].includes(a == null ? void 0 : a.toLowerCase()) || (r[a] = "[REDACTED]");
  }), r) : ((o = Object.keys(r)) == null || o.forEach((a) => {
    [...fd, ...e].includes(a == null ? void 0 : a.toLowerCase()) && (r[a] = "[REDACTED]");
  }), r);
}, fd = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], Jo = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], Ko = "X-Highlight-Request", ri = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, dd = (e, { headersToRedact: t, headersToRecord: n, requestResponseSanitizer: r }) => {
  var c, s;
  let i = e;
  if (r) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(i.response.body);
    } catch (h) {
      d = !1;
    }
    try {
      i = r(i);
    } catch (h) {
    } finally {
      f = f && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), f && (i.request.body = JSON.stringify(i.request.body)), d && (i.response.body = JSON.stringify(i.response.body));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, u = Jt(l, ["request", "response"]);
  return P({
    request: ni(o, t, n),
    response: ni(a, t, n)
  }, u);
}, ii = (e, t, n, r) => {
  e.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((c, s) => {
    const l = ri(s.name);
    return s.initiatorType === n ? c[n][l] = [
      ...c[n][l] || [],
      s
    ] : c.others[l] = [
      ...c.others[l] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce((c, s) => {
    const l = ri(s.request.url);
    return c[l] = [...c[l] || [], s], c;
  }, a);
  for (let c in o[n]) {
    const s = o[n][c], l = a[c];
    if (!l)
      continue;
    const f = Math.max(s.length - l.length, 0);
    for (let d = f; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = l[d - f]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce((c, s) => {
    let l = s.requestResponsePair;
    return l && (l = dd(s.requestResponsePair, r), !l) || (s.toJSON = function() {
      const f = window.performance.timeOrigin;
      return {
        initiatorType: this.initiatorType,
        startTimeAbs: f + this.startTime,
        connectStartAbs: f + this.connectStart,
        connectEndAbs: f + this.connectEnd,
        domainLookupStartAbs: f + this.domainLookupStart,
        domainLookupEndAbs: f + this.domainLookupEnd,
        fetchStartAbs: f + this.fetchStart,
        redirectStartAbs: f + this.redirectStart,
        redirectEndAbs: f + this.redirectEnd,
        requestStartAbs: f + this.requestStart,
        responseStartAbs: f + this.responseStart,
        responseEndAbs: f + this.responseEnd,
        secureConnectionStartAbs: f + this.secureConnectionStart,
        workerStartAbs: f + this.workerStart,
        name: this.name,
        transferSize: this.transferSize,
        encodedBodySize: this.encodedBodySize,
        decodedBodySize: this.decodedBodySize,
        nextHopProtocol: this.nextHopProtocol,
        requestResponsePairs: l
      };
    }, c.push(s)), c;
  }, []);
}, hd = (e, t) => e.toLocaleLowerCase().includes("https://pub.highlight.run") || e.toLocaleLowerCase().includes("pub.highlight.io") || e.toLocaleLowerCase().includes("otel.highlight.io") || t.some((n) => e.toLocaleLowerCase().includes(n)), zt = (e, t, n) => !hd(e, t) || Tr(e, n != null ? n : [], []), Tr = (e, t, n) => {
  var o;
  if (n.some((a) => e.toLowerCase().includes(a)))
    return !1;
  let r = [];
  t === !0 ? (r = ["localhost", /^\//], (o = window == null ? void 0 : window.location) != null && o.host && r.push(window.location.host)) : t instanceof Array && (r = t);
  let i = !1;
  return r.forEach((a) => {
    e.match(a) && (i = !0);
  }), i;
};
function pd(e) {
  for (var t = "", n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = n.length, i = 0; i < e; i++)
    t += n.charAt(Math.floor(Math.random() * r));
  return t;
}
const Sr = () => {
  const e = pd(10), t = C_(), n = t == null ? void 0 : t.spanContext().traceId;
  return [id(), n != null ? n : e];
}, Qo = (e, t) => e + "/" + t, _d = (e, t, n, r, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !r.some((d) => this._url.toLowerCase().includes(d)), u.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, s.apply(this, arguments);
  }, a.send = function(l) {
    if (!zt(this._url, t, n))
      return c.apply(this, arguments);
    const [f, d] = Sr();
    Tr(this._url, n, r) && this.setRequestHeader(Ko, Qo(f, d));
    const h = this._shouldRecordHeaderAndBody, g = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && l) {
      const p = oi(l, g.url);
      p && (this._body = p, g.body = le(p, i, o, g.headers));
    }
    return this.addEventListener("load", function() {
      return j(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const T = this.getAllResponseHeaders().trim().split(/[\r\n]+/), R = {};
          if (T.forEach(function(x) {
            const G = x.split(": "), U = G.shift();
            R[U] = G.join(": ");
          }), p.headers = R, l) {
            const x = oi(l, g.url);
            x && (g.body = le(x, i, o, p.headers));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = le(this.responseText, i, o, p.headers), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const x = yield this.response.text();
                p.body = le(x, i, o, p.headers), p.size = this.response.size;
              } catch (x) {
              }
          } else
            try {
              p.body = le(this.response, i, o, p.headers);
            } catch (x) {
            }
        }
        e({
          request: g,
          response: p,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return j(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: g,
          response: p,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, oi = (e, t) => {
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && e.includes("pushPayload")))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return Nt(e);
  return null;
}, ai = 64 * 1024, gd = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, le = (e, t, n, r) => {
  var o, a, u;
  let i = ai;
  if (r) {
    let c = "";
    typeof r.get == "function" ? c = (o = r.get("content-type")) != null ? o : "" : c = (a = r["content-type"]) != null ? a : "";
    try {
      c = c.split(";")[0];
    } catch (s) {
    }
    i = (u = gd[c]) != null ? u : ai;
  }
  if (e) {
    if (t)
      try {
        const c = JSON.parse(e);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((l) => {
            t.includes(l.toLocaleLowerCase()) && (s[l] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          t.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
    if (n)
      try {
        const c = JSON.parse(e);
        Object.keys(c).forEach((s) => {
          n.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (c) {
  }
  return e;
}, yd = (e, t, n, r, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: l } = md(u, c);
    if (!zt(l, t, n))
      return a.call(this, u, c);
    const [f, d] = Sr();
    if (Tr(l, n, r)) {
      c = c || {};
      let m = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(([y, T]) => m.set(y, T)), m.set(Ko, Qo(f, d)), c.headers = Object.fromEntries(m.entries());
    }
    const h = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: s
    }, g = !r.some((m) => l.toLowerCase().includes(m));
    g && (h.headers = Object.fromEntries(new Headers(c == null ? void 0 : c.headers).entries()), h.body = le(c == null ? void 0 : c.body, i, o, c == null ? void 0 : c.headers));
    let p = a.call(this, u, c);
    return vd(p, h, e, g, i, o), p;
  }, () => {
    window._fetchProxy = a;
  };
}, md = (e, t) => {
  const n = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let r;
  return typeof e == "object" ? "url" in e && e.url ? r = e.url : r = e.toString() : r = e, {
    method: n,
    url: r
  };
}, vd = (e, t, n, r, i, o) => {
  const a = (u) => j(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, l = !r;
    "stack" in u || u instanceof Error ? (c = H(P({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = H(P({}, c), {
      status: u.status
    }), r && (c.body = yield Zo(u, o, i), c.headers = Object.fromEntries(u.headers.entries()), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (l = !0, c = H(P({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && n({
      request: t,
      response: c,
      urlBlocked: l
    });
  });
  e.then(a).catch(() => {
  });
}, Zo = (e, t, n) => j(void 0, null, function* () {
  let r;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c, s = "";
      for (; !(c = yield a.read()).done; ) {
        let l = c.value;
        s += u.decode(l);
      }
      r = s, r = le(r, n, t, e.headers);
    } else
      r = "";
  } catch (i) {
    r = `Unable to clone response: ${i}`;
  }
  return r;
});
var ea = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, n) {
      this._delegate.export(t, n);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), Ed = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), si = (
  /** @class */
  function(e) {
    Ed(t, e);
    function t(n, r, i) {
      var o = e.call(this, n) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = r, o;
    }
    return t;
  }(Error)
);
function Td(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function Sd(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function wd(e, t, n) {
  var r, i, o, a, u, c;
  return {
    timeoutMillis: Td((i = (r = e.timeoutMillis) !== null && r !== void 0 ? r : t.timeoutMillis) !== null && i !== void 0 ? i : n.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : n.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : n.compression
  };
}
function bd() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var Od = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, Ad = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Rd = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var n = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var r = function() {
        var i = n._sendingPromises.indexOf(t);
        n._sendingPromises.splice(i, 1);
      };
      t.then(r, r);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return Od(this, void 0, void 0, function() {
        return Ad(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Nd(e) {
  return new Rd(e.concurrencyLimit);
}
function Ld(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function Id() {
  return {
    handleResponse: function(e) {
      e == null || !Ld(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || v.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var Cd = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, xd = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Pd = (
  /** @class */
  function() {
    function e(t, n, r, i, o) {
      this._transport = t, this._serializer = n, this._responseHandler = r, this._promiseQueue = i, this._timeout = o, this._diagLogger = v.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, n) {
      var r = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        n({
          code: V.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        n({
          code: V.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              r._responseHandler.handleResponse(r._serializer.deserializeResponse(o.data));
            } catch (a) {
              r._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          n({
            code: V.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          n({
            code: V.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? n({
          code: V.FAILED,
          error: new si("Export failed with retryable status")
        }) : n({
          code: V.FAILED,
          error: new si("Export failed with unknown error")
        });
      }, function(o) {
        return n({
          code: V.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return Cd(this, void 0, void 0, function() {
        return xd(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Md(e, t) {
  return new Pd(e.transport, e.serializer, Id(), e.promiseHandler, t.timeout);
}
function ta(e, t, n) {
  return Md({
    transport: n,
    serializer: t,
    promiseHandler: Nd(e)
  }, { timeout: e.timeoutMillis });
}
function na(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function kd(e) {
  var t = Number(BigInt.asUintN(32, e)), n = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: n };
}
function ra(e) {
  var t = na(e);
  return kd(t);
}
function Dd(e) {
  var t = na(e);
  return t.toString();
}
var Ud = typeof BigInt != "undefined" ? Dd : re;
function ui(e) {
  return e;
}
function ia(e) {
  if (e !== void 0)
    return pr(e);
}
var Bd = {
  encodeHrTime: ra,
  encodeSpanContext: pr,
  encodeOptionalSpanContext: ia
};
function oa(e) {
  var t, n;
  if (e === void 0)
    return Bd;
  var r = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (n = e.useHex) !== null && n !== void 0 ? n : !1;
  return {
    encodeHrTime: r ? ra : Ud,
    encodeSpanContext: i ? ui : pr,
    encodeOptionalSpanContext: i ? ui : ia
  };
}
var Hd = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function aa(e) {
  return {
    attributes: Oe(e.attributes),
    droppedAttributesCount: 0
  };
}
function sa(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Oe(e) {
  return Object.keys(e).map(function(t) {
    return ua(t, e[t]);
  });
}
function ua(e, t) {
  return {
    key: e,
    value: ca(t)
  };
}
function ca(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(ca) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(n) {
        var r = Hd(n, 2), i = r[0], o = r[1];
        return ua(i, o);
      })
    }
  } : {};
}
var Y;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(Y || (Y = {}));
var Z;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(Z || (Z = {}));
var Fd = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ci = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, li = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Gd = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Vd = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, jd = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $d(e) {
  return e != null;
}
function la(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(n) {
    return [n, e[n]];
  })));
}
function Xd(e) {
  var t, n;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((n = e.schemaUrl) !== null && n !== void 0 ? n : "");
}
var fa = (
  /** @class */
  function(e) {
    Fd(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return Object.setPrototypeOf(r, t.prototype), r;
    }
    return t;
  }(Error)
);
function rt(e, t) {
  var n, r = new Promise(function(o, a) {
    n = setTimeout(function() {
      a(new fa("Operation timed out."));
    }, t);
  });
  return Promise.race([e, r]).then(function(i) {
    return clearTimeout(n), i;
  }, function(i) {
    throw clearTimeout(n), i;
  });
}
function zd(e) {
  return ci(this, void 0, void 0, function() {
    var t = this;
    return li(this, function(n) {
      return [2, Promise.all(e.map(function(r) {
        return ci(t, void 0, void 0, function() {
          var i, o;
          return li(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, r];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function qd(e) {
  return e.status === "rejected";
}
function fi(e, t) {
  var n = [];
  return e.forEach(function(r) {
    n.push.apply(n, Vd([], Gd(t(r)), !1));
  }), n;
}
function Wd(e, t) {
  var n, r;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = jd(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    n = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (n) throw n.error;
    }
  }
  return !0;
}
function Yd(e, t) {
  for (var n = 0, r = e.length - 1, i = e.length; r >= n; ) {
    var o = n + Math.trunc((r - n) / 2);
    e[o] < t ? n = o + 1 : (i = o, r = o - 1);
  }
  return i;
}
function Jd(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var Se;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(Se || (Se = {}));
var Kd = (
  /** @class */
  function() {
    function e() {
      this.kind = Se.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, n) {
    }, e.prototype.diff = function(t, n) {
    }, e.prototype.toMetricData = function(t, n, r, i) {
    }, e;
  }()
), w;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(w || (w = {}));
function ue(e, t, n) {
  var r, i, o, a;
  return th(e) || v.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (r = n == null ? void 0 : n.description) !== null && r !== void 0 ? r : "",
    unit: (i = n == null ? void 0 : n.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = n == null ? void 0 : n.valueType) !== null && o !== void 0 ? o : fe.DOUBLE,
    advice: (a = n == null ? void 0 : n.advice) !== null && a !== void 0 ? a : {}
  };
}
function Qd(e, t) {
  var n, r;
  return {
    name: (n = e.name) !== null && n !== void 0 ? n : t.name,
    description: (r = e.description) !== null && r !== void 0 ? r : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function Zd(e, t) {
  return Jd(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var eh = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function th(e) {
  return e.match(eh) != null;
}
var nh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function rh(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var vn = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      r === void 0 && (r = !0), i === void 0 && (i = rh(n)), this.startTime = t, this._boundaries = n, this._recordMinMax = r, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var n = Yd(this._boundaries, t);
        this._current.buckets.counts[n] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), da = (
  /** @class */
  function() {
    function e(t, n) {
      this._boundaries = t, this._recordMinMax = n, this.kind = Se.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new vn(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, n) {
      for (var r = t.toPointValue(), i = n.toPointValue(), o = r.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (r.hasMinMax && i.hasMinMax ? (s = Math.min(r.min, i.min), l = Math.max(r.max, i.max)) : r.hasMinMax ? (s = r.min, l = r.max) : i.hasMinMax && (s = i.min, l = i.max)), new vn(t.startTime, r.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: r.buckets.boundaries,
          counts: u
        },
        count: r.count + i.count,
        sum: r.sum + i.sum,
        hasMinMax: this._recordMinMax && (r.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, e.prototype.diff = function(t, n) {
      for (var r = t.toPointValue(), i = n.toPointValue(), o = r.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new vn(n.startTime, r.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: r.buckets.boundaries,
          counts: u
        },
        count: i.count - r.count,
        sum: i.sum - r.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, n, r, i) {
      return {
        descriptor: t,
        aggregationTemporality: n,
        dataPointType: Z.HISTOGRAM,
        dataPoints: r.map(function(o) {
          var a = nh(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === w.GAUGE || t.type === w.UP_DOWN_COUNTER || t.type === w.OBSERVABLE_GAUGE || t.type === w.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), En = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Tn = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, di = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      t === void 0 && (t = new ih()), n === void 0 && (n = 0), r === void 0 && (r = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = n, this.indexStart = r, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(n, r) {
        return t.at(r);
      });
    }, e.prototype.at = function(t) {
      var n = this.indexBase - this.indexStart;
      return t < n && (t += this.backing.length), t -= n, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, n) {
      this.backing.increment(t, n);
    }, e.prototype.decrementBucket = function(t, n) {
      this.backing.decrement(t, n);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var n = 1 + this.indexEnd - this.indexStart, r = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % r;
        u < 0 && (u += r);
        for (var c = u; c < r && i < n; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, n) {
      t !== n && this.incrementBucket(t, this.backing.emptyBucket(n));
    }, e;
  }()
), ih = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, n, r) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, Tn([
        r,
        this._counts.length - n
      ], En(this._counts.slice(n)), !1)), i.splice.apply(i, Tn([0, n], En(this._counts.slice(0, n)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, n) {
      for (var r = Math.floor((t + n) / 2) - t, i = 0; i < r; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[n - i - 1], this._counts[n - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var n = this._counts[t];
      return this._counts[t] = 0, n;
    }, e.prototype.increment = function(t, n) {
      this._counts[t] += n;
    }, e.prototype.decrement = function(t, n) {
      this._counts[t] >= n ? this._counts[t] -= n : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(Tn([], En(this._counts), !1));
    }, e;
  }()
), oh = 52, ah = 2146435072, sh = 1048575, ha = 1023, pa = -1022, _a = ha, Jn = Math.pow(2, -1022);
function ga(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var n = t.getUint32(0), r = (n & ah) >> 20;
  return r - ha;
}
function ya(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var n = t.getUint32(0), r = t.getUint32(4), i = (n & sh) * Math.pow(2, 32);
  return i + r;
}
function Kn(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function uh(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var ch = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), it = (
  /** @class */
  function(e) {
    ch(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), lh = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < Jn)
        return this._minNormalLowerBoundaryIndex();
      var n = ga(t), r = this._rightShift(ya(t) - 1, oh);
      return n + r >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var n = this._minNormalLowerBoundaryIndex();
      if (t < n)
        throw new it("underflow: " + t + " is < minimum lower boundary: " + n);
      var r = this._maxNormalLowerBoundaryIndex();
      if (t > r)
        throw new it("overflow: " + t + " is > maximum lower boundary: " + r);
      return Kn(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = pa >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return _a >> this._shift;
    }, e.prototype._rightShift = function(t, n) {
      return Math.floor(t * Math.pow(2, -n));
    }, e;
  }()
), fh = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = Kn(Math.LOG2E, t), this._inverseFactor = Kn(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= Jn)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (ya(t) === 0) {
        var n = ga(t);
        return (n << this._scale) - 1;
      }
      var r = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return r >= i ? i : r;
    }, e.prototype.lowerBoundary = function(t) {
      var n = this._maxNormalLowerBoundaryIndex();
      if (t >= n) {
        if (t === n)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new it("overflow: " + t + " is > maximum lower boundary: " + n);
      }
      var r = this._minNormalLowerBoundaryIndex();
      if (t <= r) {
        if (t === r)
          return Jn;
        if (t === r - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new it("overflow: " + t + " is < minimum lower boundary: " + r);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return pa << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (_a + 1 << this._scale) - 1;
    }, e;
  }()
), hi = -10, pi = 20, dh = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new fh(t - 10) : new lh(t - 10);
});
function _i(e) {
  if (e > pi || e < hi)
    throw new it("expected scale >= " + hi + " && <= " + pi + ", got: " + e);
  return dh[e + 10];
}
var hh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, yt = (
  /** @class */
  function() {
    function e(t, n) {
      this.low = t, this.high = n;
    }
    return e.combine = function(t, n) {
      return new e(Math.min(t.low, n.low), Math.max(t.high, n.high));
    }, e;
  }()
), ph = 20, _h = 160, Sn = 2, gh = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a, u, c, s, l, f) {
      t === void 0 && (t = t), n === void 0 && (n = _h), r === void 0 && (r = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new di()), l === void 0 && (l = new di()), f === void 0 && (f = _i(ph)), this.startTime = t, this._maxSize = n, this._recordMinMax = r, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = f, this._maxSize < Sn && (v.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Sn), this._maxSize = Sn);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, n) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += n, t === 0) {
          this._zeroCount += n;
          return;
        }
        this._sum += t * n, t > 0 ? this._updateBuckets(this._positive, t, n) : this._updateBuckets(this._negative, -t, n);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var n = this._minScale(t);
      this._downscale(this.scale - n), this._mergeBuckets(this.positive, t, t.positive, n), this._mergeBuckets(this.negative, t, t.negative, n);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var n = this._minScale(t);
      this._downscale(this.scale - n), this._diffBuckets(this.positive, t, t.positive, n), this._diffBuckets(this.negative, t, t.negative, n);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, n, r) {
      var i = this._mapping.mapToIndex(n), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(n);
      }
      this._incrementIndexBy(t, i, r);
    }, e.prototype._incrementIndexBy = function(t, n, r) {
      if (r !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = n), n < t.indexStart) {
          var i = t.indexEnd - n;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = n;
        } else if (n > t.indexEnd) {
          var i = n - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = n;
        }
        var o = n - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, r);
      }
    }, e.prototype._grow = function(t, n) {
      var r = t.backing.length, i = t.indexBase - t.indexStart, o = r - i, a = uh(n);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, n) {
      for (var r = 0; t - n >= this._maxSize; )
        t >>= 1, n >>= 1, r++;
      return r;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var n = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = _i(n);
      }
    }, e.prototype._minScale = function(t) {
      var n = Math.min(this.scale, t.scale), r = yt.combine(this._highLowAtScale(this.positive, this.scale, n), this._highLowAtScale(t.positive, t.scale, n)), i = yt.combine(this._highLowAtScale(this.negative, this.scale, n), this._highLowAtScale(t.negative, t.scale, n));
      return Math.min(n - this._changeScale(r.high, r.low), n - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, n, r) {
      if (t.length === 0)
        return new yt(0, -1);
      var i = n - r;
      return new yt(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, n, r, i) {
      for (var o = r.offset, a = n.scale - i, u = 0; u < r.length; u++)
        this._incrementIndexBy(t, o + u >> a, r.at(u));
    }, e.prototype._diffBuckets = function(t, n, r, i) {
      for (var o = r.offset, a = n.scale - i, u = 0; u < r.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, r.at(u));
      }
      t.trim();
    }, e;
  }()
), yh = (
  /** @class */
  function() {
    function e(t, n) {
      this._maxSize = t, this._recordMinMax = n, this.kind = Se.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new gh(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, n) {
      var r = n.clone();
      return r.merge(t), r;
    }, e.prototype.diff = function(t, n) {
      var r = n.clone();
      return r.diff(t), r;
    }, e.prototype.toMetricData = function(t, n, r, i) {
      return {
        descriptor: t,
        aggregationTemporality: n,
        dataPointType: Z.EXPONENTIAL_HISTOGRAM,
        dataPoints: r.map(function(o) {
          var a = hh(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === w.GAUGE || t.type === w.UP_DOWN_COUNTER || t.type === w.OBSERVABLE_GAUGE || t.type === w.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), mh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wn = (
  /** @class */
  function() {
    function e(t, n, r) {
      n === void 0 && (n = 0), r === void 0 && (r = [0, 0]), this.startTime = t, this._current = n, this.sampleTime = r;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = z(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), vh = (
  /** @class */
  function() {
    function e() {
      this.kind = Se.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new wn(t);
    }, e.prototype.merge = function(t, n) {
      var r = lt(n.sampleTime) >= lt(t.sampleTime) ? n : t;
      return new wn(t.startTime, r.toPointValue(), r.sampleTime);
    }, e.prototype.diff = function(t, n) {
      var r = lt(n.sampleTime) >= lt(t.sampleTime) ? n : t;
      return new wn(n.startTime, r.toPointValue(), r.sampleTime);
    }, e.prototype.toMetricData = function(t, n, r, i) {
      return {
        descriptor: t,
        aggregationTemporality: n,
        dataPointType: Z.GAUGE,
        dataPoints: r.map(function(o) {
          var a = mh(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), Eh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ge = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      r === void 0 && (r = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = n, this._current = r, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), gi = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = Se.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Ge(t, this.monotonic);
    }, e.prototype.merge = function(t, n) {
      var r = t.toPointValue(), i = n.toPointValue();
      return n.reset ? new Ge(n.startTime, this.monotonic, i, n.reset) : new Ge(t.startTime, this.monotonic, r + i);
    }, e.prototype.diff = function(t, n) {
      var r = t.toPointValue(), i = n.toPointValue();
      return this.monotonic && r > i ? new Ge(n.startTime, this.monotonic, i, !0) : new Ge(n.startTime, this.monotonic, i - r);
    }, e.prototype.toMetricData = function(t, n, r, i) {
      return {
        descriptor: t,
        aggregationTemporality: n,
        dataPointType: Z.SUM,
        dataPoints: r.map(function(o) {
          var a = Eh(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), Ae = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), oe = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return ma;
    }, e.Sum = function() {
      return va;
    }, e.LastValue = function() {
      return Ea;
    }, e.Histogram = function() {
      return Ta;
    }, e.ExponentialHistogram = function() {
      return Nh;
    }, e.Default = function() {
      return Lh;
    }, e;
  }()
), Th = (
  /** @class */
  function(e) {
    Ae(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(n) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Kd(), t;
  }(oe)
), Sh = (
  /** @class */
  function(e) {
    Ae(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(n) {
      switch (n.type) {
        case w.COUNTER:
        case w.OBSERVABLE_COUNTER:
        case w.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new gi(!0), t.NON_MONOTONIC_INSTANCE = new gi(!1), t;
  }(oe)
), wh = (
  /** @class */
  function(e) {
    Ae(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(n) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new vh(), t;
  }(oe)
), bh = (
  /** @class */
  function(e) {
    Ae(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(n) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new da([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(oe)
), Oh = (
  /** @class */
  function(e) {
    Ae(t, e);
    function t(n, r) {
      r === void 0 && (r = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = r, n == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      n = n.concat(), n = n.sort(function(u, c) {
        return u - c;
      });
      var o = n.lastIndexOf(-1 / 0), a = n.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = n.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(n) {
      return new da(this._boundaries, this._recordMinMax);
    }, t;
  }(oe)
), Ah = (
  /** @class */
  function(e) {
    Ae(t, e);
    function t(n, r) {
      n === void 0 && (n = 160), r === void 0 && (r = !0);
      var i = e.call(this) || this;
      return i._maxSize = n, i._recordMinMax = r, i;
    }
    return t.prototype.createAggregator = function(n) {
      return new yh(this._maxSize, this._recordMinMax);
    }, t;
  }(oe)
), Rh = (
  /** @class */
  function(e) {
    Ae(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(n) {
      switch (n.type) {
        case w.COUNTER:
        case w.UP_DOWN_COUNTER:
        case w.OBSERVABLE_COUNTER:
        case w.OBSERVABLE_UP_DOWN_COUNTER:
          return va;
        case w.GAUGE:
        case w.OBSERVABLE_GAUGE:
          return Ea;
        case w.HISTOGRAM:
          return n.advice.explicitBucketBoundaries ? new Oh(n.advice.explicitBucketBoundaries) : Ta;
      }
      return v.warn("Unable to recognize instrument type: " + n.type), ma;
    }, t.prototype.createAggregator = function(n) {
      return this._resolve(n).createAggregator(n);
    }, t;
  }(oe)
), ma = new Th(), va = new Sh(), Ea = new wh(), Ta = new bh(), Nh = new Ah(), Lh = new Rh(), Ih = function(e) {
  return oe.Default();
}, Ch = function(e) {
  return Y.CUMULATIVE;
}, bn = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, On = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, yi = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, xh = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ph = (
  /** @class */
  function() {
    function e(t) {
      var n, r, i;
      this._shutdown = !1, this._aggregationSelector = (n = t == null ? void 0 : t.aggregationSelector) !== null && n !== void 0 ? n : Ih, this._aggregationTemporalitySelector = (r = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && r !== void 0 ? r : Ch, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return bn(this, void 0, void 0, function() {
        var n, r, i, o, a, u;
        return On(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(xh([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], yi(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return n = yi.apply(void 0, [c.sent()]), r = n[0], i = n.slice(1), o = r.errors.concat(fi(i, function(s) {
                return s.errors;
              })), a = r.resourceMetrics.resource, u = r.resourceMetrics.scopeMetrics.concat(fi(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return bn(this, void 0, void 0, function() {
        return On(this, function(n) {
          switch (n.label) {
            case 0:
              return this._shutdown ? (v.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return n.sent(), [3, 4];
            case 2:
              return [4, rt(this.onShutdown(), t.timeoutMillis)];
            case 3:
              n.sent(), n.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return bn(this, void 0, void 0, function() {
        return On(this, function(n) {
          switch (n.label) {
            case 0:
              return this._shutdown ? (v.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, rt(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), Mh = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), mt = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, vt = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, kh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Dh = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Uh = (
  /** @class */
  function(e) {
    Mh(t, e);
    function t(n) {
      var r, i, o, a, u = e.call(this, {
        aggregationSelector: (r = n.exporter.selectAggregation) === null || r === void 0 ? void 0 : r.bind(n.exporter),
        aggregationTemporalitySelector: (i = n.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(n.exporter),
        metricProducers: n.metricProducers
      }) || this;
      if (n.exportIntervalMillis !== void 0 && n.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (n.exportTimeoutMillis !== void 0 && n.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (n.exportTimeoutMillis !== void 0 && n.exportIntervalMillis !== void 0 && n.exportIntervalMillis < n.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = n.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = n.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = n.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return mt(this, void 0, void 0, function() {
        var n;
        return vt(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, rt(this._doRun(), this._exportTimeout)];
            case 1:
              return r.sent(), [3, 3];
            case 2:
              return n = r.sent(), n instanceof fa ? (v.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (de(n), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var n, r;
      return mt(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return vt(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = v).error.apply(s, Dh(["PeriodicExportingMetricReader: metrics collection errors"], kh(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (r = (n = o.resource).waitForAsyncAttributes) === null || r === void 0 ? void 0 : r.call(n)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), v.debug("Error while resolving async portion of resource: ", u), de(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, Zc._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== V.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var n = this;
      this._interval = setInterval(function() {
        n._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return mt(this, void 0, void 0, function() {
        return vt(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return n.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return mt(this, void 0, void 0, function() {
        return vt(this, function(n) {
          switch (n.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return n.sent(), [4, this._exporter.shutdown()];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(Ph)
), Bh = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, n) {
      var r = this, i = this._registeredViews.filter(function(o) {
        return r._matchInstrument(o.instrumentSelector, t) && r._matchMeter(o.meterSelector, n);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, n) {
      return (t.getType() === void 0 || n.type === t.getType()) && t.getNameFilter().match(n.name) && t.getUnitFilter().match(n.unit);
    }, e.prototype._matchMeter = function(t, n) {
      return t.getNameFilter().match(n.name) && (n.version === void 0 || t.getVersionFilter().match(n.version)) && (n.schemaUrl === void 0 || t.getSchemaUrlFilter().match(n.schemaUrl));
    }, e;
  }()
), Re = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qt = (
  /** @class */
  function() {
    function e(t, n) {
      this._writableMetricStorage = t, this._descriptor = n;
    }
    return e.prototype._record = function(t, n, r) {
      if (n === void 0 && (n = {}), r === void 0 && (r = A.active()), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === fe.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, n, r, z(Date.now()));
    }, e;
  }()
), Hh = (
  /** @class */
  function(e) {
    Re(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(n, r, i) {
      this._record(n, r, i);
    }, t;
  }(qt)
), Fh = (
  /** @class */
  function(e) {
    Re(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(n, r, i) {
      if (n < 0) {
        v.warn("negative value provided to counter " + this._descriptor.name + ": " + n);
        return;
      }
      this._record(n, r, i);
    }, t;
  }(qt)
), Gh = (
  /** @class */
  function(e) {
    Re(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(n, r, i) {
      this._record(n, r, i);
    }, t;
  }(qt)
), Vh = (
  /** @class */
  function(e) {
    Re(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(n, r, i) {
      if (n < 0) {
        v.warn("negative value provided to histogram " + this._descriptor.name + ": " + n);
        return;
      }
      this._record(n, r, i);
    }, t;
  }(qt)
), Wt = (
  /** @class */
  function() {
    function e(t, n, r) {
      this._observableRegistry = r, this._descriptor = t, this._metricStorages = n;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), jh = (
  /** @class */
  function(e) {
    Re(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Wt)
), $h = (
  /** @class */
  function(e) {
    Re(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Wt)
), Xh = (
  /** @class */
  function(e) {
    Re(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Wt)
);
function Qn(e) {
  return e instanceof Wt;
}
var zh = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, n) {
      var r = ue(t, w.GAUGE, n), i = this._meterSharedState.registerMetricStorage(r);
      return new Gh(i, r);
    }, e.prototype.createHistogram = function(t, n) {
      var r = ue(t, w.HISTOGRAM, n), i = this._meterSharedState.registerMetricStorage(r);
      return new Vh(i, r);
    }, e.prototype.createCounter = function(t, n) {
      var r = ue(t, w.COUNTER, n), i = this._meterSharedState.registerMetricStorage(r);
      return new Fh(i, r);
    }, e.prototype.createUpDownCounter = function(t, n) {
      var r = ue(t, w.UP_DOWN_COUNTER, n), i = this._meterSharedState.registerMetricStorage(r);
      return new Hh(i, r);
    }, e.prototype.createObservableGauge = function(t, n) {
      var r = ue(t, w.OBSERVABLE_GAUGE, n), i = this._meterSharedState.registerAsyncMetricStorage(r);
      return new $h(r, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, n) {
      var r = ue(t, w.OBSERVABLE_COUNTER, n), i = this._meterSharedState.registerAsyncMetricStorage(r);
      return new jh(r, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, n) {
      var r = ue(t, w.OBSERVABLE_UP_DOWN_COUNTER, n), i = this._meterSharedState.registerAsyncMetricStorage(r);
      return new Xh(r, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, n) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, n);
    }, e.prototype.removeBatchObservableCallback = function(t, n) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, n);
    }, e;
  }()
), Sa = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = ue(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), qh = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), mi = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Wh = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, n) {
      return n != null || (n = this._hash(t)), this._valueMap.get(n);
    }, e.prototype.getOrDefault = function(t, n) {
      var r = this._hash(t);
      if (this._valueMap.has(r))
        return this._valueMap.get(r);
      var i = n();
      return this._keyMap.has(r) || this._keyMap.set(r, t), this._valueMap.set(r, i), i;
    }, e.prototype.set = function(t, n, r) {
      r != null || (r = this._hash(t)), this._keyMap.has(r) || this._keyMap.set(r, t), this._valueMap.set(r, n);
    }, e.prototype.has = function(t, n) {
      return n != null || (n = this._hash(t)), this._valueMap.has(n);
    }, e.prototype.keys = function() {
      var t, n;
      return mi(this, function(r) {
        switch (r.label) {
          case 0:
            t = this._keyMap.entries(), n = t.next(), r.label = 1;
          case 1:
            return n.done === !0 ? [3, 3] : [4, [n.value[1], n.value[0]]];
          case 2:
            return r.sent(), n = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, n;
      return mi(this, function(r) {
        switch (r.label) {
          case 0:
            t = this._valueMap.entries(), n = t.next(), r.label = 1;
          case 1:
            return n.done === !0 ? [3, 3] : [4, [this._keyMap.get(n.value[0]), n.value[1], n.value[0]]];
          case 2:
            return r.sent(), n = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), me = (
  /** @class */
  function(e) {
    qh(t, e);
    function t() {
      return e.call(this, la) || this;
    }
    return t;
  }(Wh)
), Yh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wa = (
  /** @class */
  function() {
    function e(t, n) {
      this._aggregator = t, this._activeCollectionStorage = new me(), this._cumulativeMemoStorage = new me(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (n != null ? n : 2e3) - 1, this._overflowHashCode = la(this._overflowAttributes);
    }
    return e.prototype.record = function(t, n, r, i) {
      var o = this, a = this._activeCollectionStorage.get(n);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(n, a);
      }
      a == null || a.record(t);
    }, e.prototype.batchCumulate = function(t, n) {
      var r = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = Yh(i, 3), a = o[0], u = o[1], c = o[2], s = r._aggregator.createAccumulation(n);
        s == null || s.record(u);
        var l = s;
        if (r._cumulativeMemoStorage.has(a, c)) {
          var f = r._cumulativeMemoStorage.get(a, c);
          l = r._aggregator.diff(f, s);
        } else if (r._cumulativeMemoStorage.size >= r._cardinalityLimit && (a = r._overflowAttributes, c = r._overflowHashCode, r._cumulativeMemoStorage.has(a, c))) {
          var f = r._cumulativeMemoStorage.get(a, c);
          l = r._aggregator.diff(f, s);
        }
        if (r._activeCollectionStorage.has(a, c)) {
          var d = r._activeCollectionStorage.get(a, c);
          l = r._aggregator.merge(d, l);
        }
        r._cumulativeMemoStorage.set(a, s, c), r._activeCollectionStorage.set(a, l, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new me(), t;
    }, e;
  }()
), An = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, vi = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ba = (
  /** @class */
  function() {
    function e(t, n) {
      var r = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), n.forEach(function(i) {
        r._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, n, r, i) {
      this._stashAccumulations(r);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === Y.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(n.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = Jh(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          n,
          u,
          l,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var n, r, i = this._unreportedAccumulations.keys();
      try {
        for (var o = An(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        n = { error: s };
      } finally {
        try {
          a && !a.done && (r = o.return) && r.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var n, r, i = new me(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = An(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        n = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return i;
    }, e.merge = function(t, n, r) {
      for (var i = t, o = n.entries(), a = o.next(); a.done !== !0; ) {
        var u = vi(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (t.has(c, l)) {
          var f = t.get(c, l), d = r.merge(f, s);
          i.set(c, d, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, n, r) {
      var i, o;
      try {
        for (var a = An(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = vi(u.value, 2), s = c[0], l = c[1], f = n.get(s, l);
          f == null || f.setStartTime(r);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return n;
    }, e;
  }()
);
function Jh(e) {
  return Array.from(e.entries());
}
var Kh = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Qh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Zh = (
  /** @class */
  function(e) {
    Kh(t, e);
    function t(n, r, i, o, a) {
      var u = e.call(this, n) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new wa(r, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ba(r, o), u;
    }
    return t.prototype.record = function(n, r) {
      var i = this, o = new me();
      Array.from(n.entries()).forEach(function(a) {
        var u = Qh(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, r);
    }, t.prototype.collect = function(n, r) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(n, this._instrumentDescriptor, i, r);
    }, t;
  }(Sa)
);
function Ei(e, t) {
  var n = "";
  return e.unit !== t.unit && (n += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (n += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (n += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (n += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), n;
}
function ep(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function tp(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function np(e, t) {
  var n = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, r = JSON.stringify(n);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + r + "'";
}
function rp(e, t) {
  var n = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, r = JSON.stringify(n);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + r + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + r + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + r;
}
function Ti(e, t) {
  return e.valueType !== t.valueType ? ep(e, t) : e.unit !== t.unit ? tp(e, t) : e.type !== t.type ? np(e, t) : e.description !== t.description ? rp(e, t) : "";
}
var Rn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ip = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var n, r, i, o, a = [];
      try {
        for (var u = Rn(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (h) {
        n = { error: h };
      } finally {
        try {
          c && !c.done && (r = u.return) && r.call(u);
        } finally {
          if (n) throw n.error;
        }
      }
      var l = this._perCollectorRegistry.get(t);
      if (l != null)
        try {
          for (var f = Rn(l.values()), d = f.next(); !d.done; d = f.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            d && !d.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, n) {
      var r = this._perCollectorRegistry.get(t);
      r == null && (r = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, r)), this._registerStorage(n, r);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var n = this._sharedRegistry.get(t.name);
      return n === void 0 ? null : this._findOrUpdateCompatibleStorage(t, n);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, n) {
      var r = this._perCollectorRegistry.get(t);
      if (r === void 0)
        return null;
      var i = r.get(n.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(n, i);
    }, e.prototype._registerStorage = function(t, n) {
      var r = t.getInstrumentDescriptor(), i = n.get(r.name);
      if (i === void 0) {
        n.set(r.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, n) {
      var r, i, o = null;
      try {
        for (var a = Rn(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          Zd(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), v.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, Ei(s, t), `The longer description will be used.
To resolve the conflict:`, Ti(s, t))), o = c) : v.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, Ei(s, t), `To resolve the conflict:
`, Ti(s, t));
        }
      } catch (l) {
        r = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return o;
    }, e;
  }()
), op = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, n, r, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, n, r, i);
      });
    }, e;
  }()
), ap = (
  /** @class */
  function() {
    function e(t, n) {
      this._instrumentName = t, this._valueType = n, this._buffer = new me();
    }
    return e.prototype.observe = function(t, n) {
      if (n === void 0 && (n = {}), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === fe.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(n, t);
    }, e;
  }()
), sp = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, n, r) {
      if (r === void 0 && (r = {}), !!Qn(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new me(), this._buffer.set(t, i)), typeof n != "number") {
          v.warn("non-number value provided to metric " + t._descriptor.name + ": " + n);
          return;
        }
        t._descriptor.valueType === fe.INT && !Number.isInteger(n) && (v.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), n = Math.trunc(n), !Number.isInteger(n)) || i.set(r, n);
      }
    }, e;
  }()
), Nn = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, Ln = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Si = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wi = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, up = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, n) {
      var r = this._findCallback(t, n);
      r >= 0 || this._callbacks.push({ callback: t, instrument: n });
    }, e.prototype.removeCallback = function(t, n) {
      var r = this._findCallback(t, n);
      r < 0 || this._callbacks.splice(r, 1);
    }, e.prototype.addBatchCallback = function(t, n) {
      var r = new Set(n.filter(Qn));
      if (r.size === 0) {
        v.error("BatchObservableCallback is not associated with valid instruments", n);
        return;
      }
      var i = this._findBatchCallback(t, r);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: r });
    }, e.prototype.removeBatchCallback = function(t, n) {
      var r = new Set(n.filter(Qn)), i = this._findBatchCallback(t, r);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, n) {
      return Nn(this, void 0, void 0, function() {
        var r, i, o, a;
        return Ln(this, function(u) {
          switch (u.label) {
            case 0:
              return r = this._observeCallbacks(t, n), i = this._observeBatchCallbacks(t, n), [4, zd(wi(wi([], Si(r), !1), Si(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(qd).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, n) {
      var r = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return Nn(r, void 0, void 0, function() {
          var u, c;
          return Ln(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new ap(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), n != null && (c = rt(c, n)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, n) {
      var r = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return Nn(r, void 0, void 0, function() {
          var u, c;
          return Ln(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new sp(), c = Promise.resolve(o(u)), n != null && (c = rt(c, n)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var f = u._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(d) {
                    d.record(f, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, n) {
      return this._callbacks.findIndex(function(r) {
        return r.callback === t && r.instrument === n;
      });
    }, e.prototype._findBatchCallback = function(t, n) {
      return this._batchCallbacks.findIndex(function(r) {
        return r.callback === t && Wd(r.instruments, n);
      });
    }, e;
  }()
), cp = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), lp = (
  /** @class */
  function(e) {
    cp(t, e);
    function t(n, r, i, o, a) {
      var u = e.call(this, n) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new wa(r, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ba(r, o), u;
    }
    return t.prototype.record = function(n, r, i, o) {
      r = this._attributesProcessor.process(r, i), this._deltaMetricStorage.record(n, r, i, o);
    }, t.prototype.collect = function(n, r) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(n, this._instrumentDescriptor, i, r);
    }, t;
  }(Sa)
), Oa = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), wr = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return dp;
    }, e;
  }()
), fp = (
  /** @class */
  function(e) {
    Oa(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(n, r) {
      return n;
    }, t;
  }(wr)
);
(function(e) {
  Oa(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r._allowedAttributeNames = n, r;
  }
  return t.prototype.process = function(n, r) {
    var i = this, o = {};
    return Object.keys(n).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = n[a];
    }), o;
  }, t;
})(wr);
var dp = new fp(), hp = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, pp = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, _p = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, gp = (
  /** @class */
  function() {
    function e(t, n) {
      this._meterProviderSharedState = t, this._instrumentationScope = n, this.metricStorageRegistry = new ip(), this.observableRegistry = new up(), this.meter = new zh(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var n = this._registerMetricStorage(t, lp);
      return n.length === 1 ? n[0] : new op(n);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var n = this._registerMetricStorage(t, Zh);
      return n;
    }, e.prototype.collect = function(t, n, r) {
      return hp(this, void 0, void 0, function() {
        var i, o, a;
        return pp(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(n, r == null ? void 0 : r.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, n);
              }).filter($d), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, n) {
      var r = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = Qd(c, t), l = r.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var f = c.aggregation.createAggregator(s), d = new n(s, f, c.attributesProcessor, r._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return r.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = _p(c, 2), l = s[0], f = s[1], d = r.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, t);
          if (d != null)
            return d;
          var h = f.createAggregator(t), g = l.selectCardinalityLimit(t.type), p = new n(t, h, wr.Noop(), [l], g);
          return r.metricStorageRegistry.registerForCollector(l, p), p;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), yp = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, mp = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new Bh(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var n = Xd(t), r = this.meterSharedStates.get(n);
      return r == null && (r = new gp(this, t), this.meterSharedStates.set(n, r)), r;
    }, e.prototype.selectAggregations = function(t) {
      var n, r, i = [];
      try {
        for (var o = yp(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (r = o.return) && r.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
      return i;
    }, e;
  }()
), Et = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, Tt = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, vp = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ep = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Tp = (
  /** @class */
  function() {
    function e(t, n) {
      this._sharedState = t, this._metricReader = n;
    }
    return e.prototype.collect = function(t) {
      return Et(this, void 0, void 0, function() {
        var n, r, i, o, a = this;
        return Tt(this, function(u) {
          switch (u.label) {
            case 0:
              return n = z(Date.now()), r = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Et(a, void 0, void 0, function() {
                  var s;
                  return Tt(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, n, t)];
                      case 1:
                        return s = l.sent(), (s == null ? void 0 : s.scopeMetrics) != null && r.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, Ep([], vp(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: r
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Et(this, void 0, void 0, function() {
        return Tt(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Et(this, void 0, void 0, function() {
        return Tt(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var n, r, i;
      return (i = (r = (n = this._metricReader).selectCardinalityLimit) === null || r === void 0 ? void 0 : r.call(n, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), bi = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, Oi = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ai = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Sp(e, t) {
  var n = t != null ? t : tt.empty();
  return e ? tt.default().merge(n) : n;
}
var wp = (
  /** @class */
  function() {
    function e(t) {
      var n, r, i, o, a;
      if (this._shutdown = !1, this._sharedState = new mp(Sp((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = Ai(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (h) {
          n = { error: h };
        } finally {
          try {
            c && !c.done && (r = u.return) && r.call(u);
          } finally {
            if (n) throw n.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var l = Ai(t.readers), f = l.next(); !f.done; f = l.next()) {
            var d = f.value;
            this.addMetricReader(d);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            f && !f.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, n, r) {
      return n === void 0 && (n = ""), r === void 0 && (r = {}), this._shutdown ? (v.warn("A shutdown MeterProvider cannot provide a Meter"), Ns()) : this._sharedState.getMeterSharedState({
        name: t,
        version: n,
        schemaUrl: r.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var n = new Tp(this._sharedState, t);
      t.setMetricProducer(n), this._sharedState.metricCollectors.push(n);
    }, e.prototype.shutdown = function(t) {
      return bi(this, void 0, void 0, function() {
        return Oi(this, function(n) {
          switch (n.label) {
            case 0:
              return this._shutdown ? (v.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(r) {
                return r.shutdown(t);
              }))]);
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return bi(this, void 0, void 0, function() {
        return Oi(this, function(n) {
          switch (n.label) {
            case 0:
              return this._shutdown ? (v.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(r) {
                return r.forceFlush(t);
              }))];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function bp(e, t) {
  var n = oa(t);
  return {
    resource: aa(e.resource),
    schemaUrl: void 0,
    scopeMetrics: Op(e.scopeMetrics, n)
  };
}
function Op(e, t) {
  return Array.from(e.map(function(n) {
    return {
      scope: sa(n.scope),
      metrics: n.metrics.map(function(r) {
        return Ap(r, t);
      }),
      schemaUrl: n.scope.schemaUrl
    };
  }));
}
function Ap(e, t) {
  var n = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, r = Ip(e.aggregationTemporality);
  switch (e.dataPointType) {
    case Z.SUM:
      n.sum = {
        aggregationTemporality: r,
        isMonotonic: e.isMonotonic,
        dataPoints: Ri(e, t)
      };
      break;
    case Z.GAUGE:
      n.gauge = {
        dataPoints: Ri(e, t)
      };
      break;
    case Z.HISTOGRAM:
      n.histogram = {
        aggregationTemporality: r,
        dataPoints: Np(e, t)
      };
      break;
    case Z.EXPONENTIAL_HISTOGRAM:
      n.exponentialHistogram = {
        aggregationTemporality: r,
        dataPoints: Lp(e, t)
      };
      break;
  }
  return n;
}
function Rp(e, t, n) {
  var r = {
    attributes: Oe(e.attributes),
    startTimeUnixNano: n.encodeHrTime(e.startTime),
    timeUnixNano: n.encodeHrTime(e.endTime)
  };
  switch (t) {
    case fe.INT:
      r.asInt = e.value;
      break;
    case fe.DOUBLE:
      r.asDouble = e.value;
      break;
  }
  return r;
}
function Ri(e, t) {
  return e.dataPoints.map(function(n) {
    return Rp(n, e.descriptor.valueType, t);
  });
}
function Np(e, t) {
  return e.dataPoints.map(function(n) {
    var r = n.value;
    return {
      attributes: Oe(n.attributes),
      bucketCounts: r.buckets.counts,
      explicitBounds: r.buckets.boundaries,
      count: r.count,
      sum: r.sum,
      min: r.min,
      max: r.max,
      startTimeUnixNano: t.encodeHrTime(n.startTime),
      timeUnixNano: t.encodeHrTime(n.endTime)
    };
  });
}
function Lp(e, t) {
  return e.dataPoints.map(function(n) {
    var r = n.value;
    return {
      attributes: Oe(n.attributes),
      count: r.count,
      min: r.min,
      max: r.max,
      sum: r.sum,
      positive: {
        offset: r.positive.offset,
        bucketCounts: r.positive.bucketCounts
      },
      negative: {
        offset: r.negative.offset,
        bucketCounts: r.negative.bucketCounts
      },
      scale: r.scale,
      zeroCount: r.zeroCount,
      startTimeUnixNano: t.encodeHrTime(n.startTime),
      timeUnixNano: t.encodeHrTime(n.endTime)
    };
  });
}
function Ip(e) {
  switch (e) {
    case Y.DELTA:
      return 1;
    case Y.CUMULATIVE:
      return 2;
  }
}
function Cp(e, t) {
  return {
    resourceMetrics: e.map(function(n) {
      return bp(n, t);
    })
  };
}
var xp = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Pp = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Mp(e, t) {
  var n, r = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(r.traceId),
    spanId: t.encodeSpanContext(r.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (n = r.traceState) === null || n === void 0 ? void 0 : n.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: Oe(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return Dp(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return kp(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function kp(e, t) {
  var n;
  return {
    attributes: e.attributes ? Oe(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (n = e.context.traceState) === null || n === void 0 ? void 0 : n.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Dp(e, t) {
  return {
    attributes: e.attributes ? Oe(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Up(e, t) {
  var n = oa(t);
  return {
    resourceSpans: Hp(e, n)
  };
}
function Bp(e) {
  var t, n, r = /* @__PURE__ */ new Map();
  try {
    for (var i = xp(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = r.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), r.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
function Hp(e, t) {
  for (var n = Bp(e), r = [], i = n.entries(), o = i.next(); !o.done; ) {
    for (var a = Pp(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return Mp(p, t);
        });
        s.push({
          scope: sa(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var g = {
      resource: aa(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    r.push(g), o = i.next();
  }
  return r;
}
var Fp = {
  serializeRequest: function(e) {
    var t = Cp([e], {
      useLongBits: !1
    }), n = new TextEncoder();
    return n.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, Gp = {
  serializeRequest: function(e) {
    var t = Up(e, {
      useHex: !0,
      useLongBits: !1
    }), n = new TextEncoder();
    return n.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, Vp = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function u(l) {
      try {
        s(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((r = r.apply(e, t || [])).next());
  });
}, jp = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = s;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(s);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, $p = 5, Xp = 1e3, zp = 5e3, qp = 1.5, Ni = 0.2;
function Wp() {
  return Math.random() * (2 * Ni) - Ni;
}
var Yp = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, n, r) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, n).then(o, a);
        }, r);
      });
    }, e.prototype.send = function(t, n) {
      var r;
      return Vp(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return jp(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + n, [4, this._transport.send(t, n)];
            case 1:
              o = f.sent(), a = $p, u = Xp, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, zp) + Wp(), 0), u = u * qp, s = (r = o.retryInMillis) !== null && r !== void 0 ? r : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(t, l, s)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function Aa(e) {
  return new Yp(e.transport);
}
function Jp(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function Kp(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var n = new Date(e).getTime() - Date.now();
    return n >= 0 ? n : 0;
  }
}
var Qp = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Zp = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, n) {
      var r = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = n, o.open("POST", r._parameters.url);
        var a = r._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = Qp(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (v.debug("XHR success"), i({
            status: "success"
          })) : o.status && Jp(o.status) ? i({
            status: "retryable",
            retryInMillis: Kp(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function e_(e) {
  return new Zp(e);
}
var t_ = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var n = this;
      return new Promise(function(r) {
        navigator.sendBeacon(n._params.url, new Blob([t], { type: n._params.blobType })) ? (v.debug("SendBeacon success"), r({
          status: "success"
        })) : r({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function n_(e) {
  return new t_(e);
}
function r_(e, t) {
  return ta(e, t, Aa({
    transport: e_(e)
  }));
}
function i_(e, t) {
  return ta(e, t, Aa({
    transport: n_({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var o_ = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function a_(e) {
  return function() {
    var t, n = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(r) {
      var i = o_(r, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? n[o] = String(a) : v.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), n;
  };
}
var we = function() {
  return we = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, we.apply(this, arguments);
};
function s_(e, t, n) {
  var r = we({}, n()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, r);
  };
}
function u_(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function c_(e, t, n) {
  var r, i, o, a;
  return we(we({}, wd(e, t, n)), { headers: s_(a_(e.headers), t.headers, n.headers), url: (i = (r = u_(e.url)) !== null && r !== void 0 ? r : t.url) !== null && i !== void 0 ? i : n.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : n.agentOptions });
}
function l_(e, t) {
  return we(we({}, bd()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function f_(e, t, n) {
  return c_(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: Sd(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    l_(n, t)
  );
}
function Ra(e, t, n, r) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = f_(e, n, r);
  return i ? r_(o, t) : i_(o, t);
}
var d_ = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Li = (
  /** @class */
  function(e) {
    d_(t, e);
    function t(n) {
      return n === void 0 && (n = {}), e.call(this, Ra(n, Gp, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(ea)
), Ut;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(Ut || (Ut = {}));
var h_ = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Zn = function() {
  return Y.CUMULATIVE;
}, Na = function(e) {
  switch (e) {
    case w.COUNTER:
    case w.OBSERVABLE_COUNTER:
    case w.GAUGE:
    case w.HISTOGRAM:
    case w.OBSERVABLE_GAUGE:
      return Y.DELTA;
    case w.UP_DOWN_COUNTER:
    case w.OBSERVABLE_UP_DOWN_COUNTER:
      return Y.CUMULATIVE;
  }
}, La = function(e) {
  switch (e) {
    case w.COUNTER:
    case w.HISTOGRAM:
      return Y.DELTA;
    case w.GAUGE:
    case w.UP_DOWN_COUNTER:
    case w.OBSERVABLE_UP_DOWN_COUNTER:
    case w.OBSERVABLE_COUNTER:
    case w.OBSERVABLE_GAUGE:
      return Y.CUMULATIVE;
  }
};
function p_() {
  var e = xe(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? Zn : t === "delta" ? Na : t === "lowmemory" ? La : (v.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Zn);
}
function __(e) {
  return e != null ? e === Ut.DELTA ? Na : e === Ut.LOWMEMORY ? La : Zn : p_();
}
function g_(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return oe.Default();
  };
}
var y_ = (
  /** @class */
  function(e) {
    h_(t, e);
    function t(n, r) {
      var i = e.call(this, n) || this;
      return i._aggregationSelector = g_(r), i._aggregationTemporalitySelector = __(r == null ? void 0 : r.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(n) {
      return this._aggregationSelector(n);
    }, t.prototype.selectAggregationTemporality = function(n) {
      return this._aggregationTemporalitySelector(n);
    }, t;
  }(ea)
), m_ = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ii = (
  /** @class */
  function(e) {
    m_(t, e);
    function t(n) {
      return e.call(this, Ra(n != null ? n : {}, Fp, "v1/metrics", { "Content-Type": "application/json" }), n) || this;
    }
    return t;
  }(y_)
);
class Ke extends Error {
  constructor(t, n) {
    const r = `${Ke.extractMessage(t)}: ${JSON.stringify({
      response: t,
      request: n
    })}`;
    super(r), Object.setPrototypeOf(this, Ke.prototype), this.response = t, this.request = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ke);
  }
  static extractMessage(t) {
    var n, r, i;
    return (i = (r = (n = t.errors) == null ? void 0 : n[0]) == null ? void 0 : r.message) != null ? i : `GraphQL Error (Code: ${t.status})`;
  }
}
var er;
(function(e) {
  e.BillingQuotaExceeded = "BillingQuotaExceeded";
})(er || (er = {}));
const br = 10, v_ = 1e3, E_ = 500, T_ = [er.BillingQuotaExceeded.toString()], S_ = (e) => {
  var n;
  return ((n = e.response.errors) == null ? void 0 : n.find((r) => T_.includes(r.message))) === void 0;
}, eg = (e) => {
  const t = (n, r, i, o, a = 0) => j(void 0, null, function* () {
    try {
      return yield n();
    } catch (u) {
      if (u instanceof Ke && !S_(u))
        throw u;
      if (a < br)
        return yield new Promise((c) => setTimeout(c, v_ + E_ * Math.pow(2, a))), yield t(n, r, i, o, a + 1);
      throw console.error(`highlight.io: [${e || e}] data request failed after ${a} retries`), u;
    }
  });
  return t;
};
class w_ extends Li {
  constructor(n) {
    super(n);
    b(this, "xhrTraceExporter");
    this.xhrTraceExporter = new Li(H(P({}, n != null ? n : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  export(n, r) {
    let i = 0;
    const o = (a) => {
      var u;
      i++, i > br ? (console.error(`[highlight.io] failed to export OTeL traces: ${(u = a.error) == null ? void 0 : u.message}`, a.error), r({
        code: V.FAILED,
        error: a.error
      })) : this.xhrTraceExporter.export(n, r);
    };
    super.export(n, o);
  }
}
class b_ extends Ii {
  constructor(n) {
    super(n);
    b(this, "xhrMeterExporter");
    this.xhrMeterExporter = new Ii(H(P({}, n != null ? n : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  export(n, r) {
    let i = 0;
    const o = (a) => {
      var u;
      i++, i > br ? (console.error(`[highlight.io] failed to export OTeL metrics: ${(u = a.error) == null ? void 0 : u.message}`, a.error), r({
        code: V.FAILED,
        error: a.error
      })) : this.xhrMeterExporter.export(n, r);
    };
    super.export(n, o);
  }
}
const O_ = "OT_ZONE_CONTEXT", A_ = "Navigation:";
function R_() {
  return !1;
}
const K = class K extends Vt {
  constructor(n = {}) {
    super(K.moduleName, K.version, n);
    b(this, "_spansData", /* @__PURE__ */ new WeakMap());
    b(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    b(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    b(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    b(this, "_shouldPreventSpanCreation");
    this._shouldPreventSpanCreation = typeof (n == null ? void 0 : n.shouldPreventSpanCreation) == "function" ? n.shouldPreventSpanCreation : R_;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(n, r) {
    const i = this._spansData.get(r);
    i && (n.source === "setTimeout" ? i.hrTimeLastTimeout = Ee() : n.source !== "Promise.then" && n.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(n) {
    return !0;
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(n, r) {
    var u;
    const i = n == null ? void 0 : n.target, o = n == null ? void 0 : n.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = Po(i, !0);
    try {
      const c = this.tracer.startSpan(o, {
        attributes: {
          "event.type": o,
          "event.tag": i.tagName,
          "event.xpath": a,
          "event.id": i.id,
          "event.text": (u = i.textContent) != null ? u : "",
          "event.url": window.location.href,
          "viewport.width": window.innerWidth,
          "viewport.height": window.innerHeight
        }
      }, r ? L.setSpan(A.active(), r) : void 0);
      return n instanceof MouseEvent && (c.setAttribute("event.x", n.clientX), c.setAttribute("event.y", n.clientY), c.setAttribute("event.relativeX", n.clientX / window.innerWidth), c.setAttribute("event.relativeY", n.clientY / window.innerHeight), o === "scroll" && (c.setAttribute("event.scrollX", window.scrollX), c.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, c) === !0 ? void 0 : (this._spansData.set(c, {
        taskCount: 0
      }), c);
    } catch (c) {
      this._diag.error("failed to start create new user interaction span", c);
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(n) {
    const r = this._spansData.get(n);
    r && (r.taskCount--, r.taskCount === 0 && this._tryToEndSpan(n, r.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(n) {
    const r = n.get(O_);
    return r && L.getSpan(r);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(n) {
    const r = this._spansData.get(n);
    r && r.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(n, r, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(r);
    return u || (u = /* @__PURE__ */ new Map(), a.set(r, u)), u.has(n) ? !1 : (u.set(n, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(n, r, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(r);
    if (!a)
      return;
    const u = a.get(n);
    return u && (a.delete(n), a.size === 0 && (o.delete(r), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(n, r, i) {
    return typeof n == "function" ? n.apply(r, i) : n.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const n = this;
    let r = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, l = function(...f) {
        var p;
        let d;
        const h = f[0];
        if (!(h != null && h.type))
          return n._invokeListener(u, this, f);
        if (Date.now() - ((p = r.get(h.type)) != null ? p : 0) < 1e3 / 60)
          return n._invokeListener(u, this, f);
        r.set(h.type, Date.now()), h && (d = n._eventsSpanMap.get(h)), s && n.removePatchedListener(this, a, u);
        const g = n._createSpan(h, d);
        return g ? (h && n._eventsSpanMap.set(h, g), A.with(L.setSpan(A.active(), g), () => {
          const m = n._invokeListener(u, this, f);
          return g.end(), m;
        })) : n._invokeListener(u, this, f);
      };
      if (n.addPatchedListener(this, a, u, l))
        return i.call(this, a, l, c);
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const n = this;
    return (r) => function(o, a, u) {
      const c = n.removePatchedListener(this, o, a);
      return c ? r.call(this, o, c, u) : r.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const n = this;
    return (r) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = r.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && n._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    M(history.replaceState) && this._unwrap(history, "replaceState"), M(history.pushState) && this._unwrap(history, "pushState"), M(history.back) && this._unwrap(history, "back"), M(history.forward) && this._unwrap(history, "forward"), M(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(n) {
    const r = L.getSpan(A.active());
    r && typeof r.updateName == "function" && r.updateName(`${A_} ${n}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const n = this;
    return (r) => function(o) {
      const a = Zone.current, u = n._getCurrentSpan(a);
      return u && n._shouldCountTask(o, a) && n._decrementTask(u), r.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const n = this;
    return (r) => function(o) {
      const a = Zone.current, u = n._getCurrentSpan(a);
      return u && n._shouldCountTask(o, a) && (n._incrementTask(u), n._checkForTimeout(o, u)), r.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const n = this;
    return (r) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let l;
      const f = this;
      if (s) {
        if (l = n._createSpan(c), l)
          return n._incrementTask(l), f.run(() => {
            try {
              return A.with(L.setSpan(A.active(), l), () => {
                const d = Zone.current;
                return o._zone = d, r.call(d, o, a, u);
              });
            } finally {
              n._decrementTask(l);
            }
          });
      } else
        l = n._getCurrentSpan(f);
      try {
        return r.call(f, o, a, u);
      } finally {
        l && n._shouldCountTask(o, f) && n._decrementTask(l);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(n, r) {
    if (n._zone && (r = n._zone), !r || !n.data || n.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(r);
    return !i || !this._spansData.get(i) ? !1 : n.type === "macroTask" || n.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(n, r) {
    n && this._spansData.get(n) && (n.end(r), this._spansData.delete(n));
  }
  /**
   * implements enable function
   */
  enable() {
    const n = this._getZoneWithPrototype();
    this._diag.debug("applying patch to", K.moduleName, K.version, "zone:", !!n), n ? (M(n.prototype.runTask) && (this._unwrap(n.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), M(n.prototype.scheduleTask) && (this._unwrap(n.prototype, "scheduleTask"), this._diag.debug("removing previous patch from method scheduleTask")), M(n.prototype.cancelTask) && (this._unwrap(n.prototype, "cancelTask"), this._diag.debug("removing previous patch from method cancelTask")), this._zonePatched = !0, this._wrap(n.prototype, "runTask", this._patchZoneRunTask()), this._wrap(n.prototype, "scheduleTask", this._patchZoneScheduleTask()), this._wrap(n.prototype, "cancelTask", this._patchZoneCancelTask())) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      M(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug("removing previous patch from method addEventListener")), M(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug("removing previous patch from method removeEventListener")), this._wrap(i, "addEventListener", this._patchAddEventListener()), this._wrap(i, "removeEventListener", this._patchRemoveEventListener());
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const n = this._getZoneWithPrototype();
    this._diag.debug("removing patch from", K.moduleName, K.version, "zone:", !!n), n && this._zonePatched ? (M(n.prototype.runTask) && this._unwrap(n.prototype, "runTask"), M(n.prototype.scheduleTask) && this._unwrap(n.prototype, "scheduleTask"), M(n.prototype.cancelTask) && this._unwrap(n.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      M(i.addEventListener) && this._unwrap(i, "addEventListener"), M(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
b(K, "version", "0.1.0"), b(K, "moduleName", "user-interaction");
let tr = K, $ = {};
const Bt = "highlight.record", tg = (e) => {
  var d, h, g, p, m;
  if ($.tracerProvider !== void 0) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  const t = e.backendUrl || "https://pub.highlight.run", n = [
    ...(h = (d = e.networkRecordingOptions) == null ? void 0 : d.urlBlocklist) != null ? h : [],
    ...Jo
  ], r = (g = e.environment) != null ? g : "production", i = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 100,
    timeoutMillis: 5e3,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 5e3,
      keepAlive: !0
    }
  }, o = new w_(i), a = new N_(o, {
    maxExportBatchSize: 100,
    maxQueueSize: 1e3,
    exportTimeoutMillis: i.timeoutMillis,
    scheduledDelayMillis: i.timeoutMillis
  }), u = new tt({
    [uc]: (p = e.serviceName) != null ? p : "highlight-browser",
    [rc]: r,
    "highlight.project_id": e.projectId,
    "highlight.session_id": e.sessionSecureId
  });
  $.tracerProvider = new Ul({
    resource: u,
    spanProcessors: [a]
  }), L.setGlobalTracerProvider($.tracerProvider);
  const c = new b_(H(P({}, i), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), s = new Uh({
    exporter: c,
    exportIntervalMillis: i.timeoutMillis,
    exportTimeoutMillis: i.timeoutMillis
  });
  $.meterProvider = new wp({ resource: u, readers: [s] }), fr.setGlobalMeterProvider($.meterProvider);
  let l = [
    new Yl({
      applyCustomAttributesOnSpan: {
        documentLoad: Pi,
        documentFetch: Pi,
        resourceFetch: M_
      }
    }),
    new tr()
  ];
  (m = e.networkRecordingOptions) != null && m.enabled && (l.push(new lf({
    propagateTraceHeaderCorsUrls: Mi(e.tracingOrigins),
    applyCustomAttributesOnSpan: (y, T, R) => j(void 0, null, function* () {
      var J, se, ut;
      const x = y;
      if (x.attributes[Bt] === !1)
        return;
      const G = x.attributes["http.url"], U = (J = T.method) != null ? J : "GET";
      if (y.updateName(Ci(G, U, T.body)), !(R instanceof Response)) {
        y.setAttributes({
          "http.response.error": R.message,
          "http.response.status": R.status
        });
        return;
      }
      xi(y, T.body, T.headers, e.networkRecordingOptions);
      const ae = yield Zo(R, (se = e.networkRecordingOptions) == null ? void 0 : se.bodyKeysToRecord, (ut = e.networkRecordingOptions) == null ? void 0 : ut.networkBodyKeysToRedact);
      y.setAttribute("http.response.body", ae);
    })
  })), l.push(new vf({
    propagateTraceHeaderCorsUrls: Mi(e.tracingOrigins),
    applyCustomAttributesOnSpan: (y, T) => {
      var ae, J;
      const R = T;
      if (y.attributes[Bt] === !1)
        return;
      const G = Ci(R._url, R._method, T.responseText);
      y.updateName(G), xi(y, R._body, R._requestHeaders, e.networkRecordingOptions);
      const U = le(R._body, (ae = e.networkRecordingOptions) == null ? void 0 : ae.networkBodyKeysToRedact, (J = e.networkRecordingOptions) == null ? void 0 : J.bodyKeysToRecord, R._requestHeaders);
      y.setAttribute("http.request.body", U);
    }
  }))), ul({ instrumentations: l });
  const f = new Io();
  f.enable(), $.tracerProvider.register({
    contextManager: f,
    propagator: new fo({
      propagators: [
        new Zi(),
        new L_({
          backendUrl: t,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  });
};
class N_ extends Lo {
  onEnd(t) {
    t.attributes[Bt] !== !1 && super.onEnd(t);
  }
}
class L_ extends ho {
  constructor(n) {
    super();
    b(this, "highlightEndpoints");
    b(this, "tracingOrigins");
    b(this, "urlBlocklist");
    this.highlightEndpoints = [n.backendUrl, n.otlpEndpoint], this.tracingOrigins = n.tracingOrigins, this.urlBlocklist = n.urlBlocklist;
  }
  inject(n, r, i) {
    const o = L.getSpan(n);
    if (!o)
      return;
    const a = o.attributes["http.url"];
    if (typeof a == "string" && !P_(a, this.highlightEndpoints, this.tracingOrigins, this.urlBlocklist)) {
      o.setAttribute(Bt, !1);
      return;
    }
    super.inject(n, r, i);
  }
}
const Ia = "highlight-browser", I_ = Ia, ng = () => $.tracerProvider.getTracer(Ia), rg = () => $.meterProvider.getMeter(I_), C_ = () => L.getActiveSpan(), x_ = () => j(void 0, null, function* () {
  yield $.tracerProvider.forceFlush(), yield $.tracerProvider.shutdown(), yield $.meterProvider.forceFlush(), yield $.meterProvider.shutdown();
}), Ci = (e, t, n) => {
  var u, c, s;
  let r;
  const i = new URL(e), o = i.pathname;
  let a = `${t.toUpperCase()} - ${o}`;
  try {
    if (r = typeof n == "string" ? JSON.parse(n) : n, r && r.query) {
      const l = Jf(r.query), f = ((u = l.definitions[0]) == null ? void 0 : u.kind) === "OperationDefinition" ? (s = (c = l.definitions[0]) == null ? void 0 : c.name) == null ? void 0 : s.value : void 0;
      f && (a = `${f} (GraphQL: ${i.host + i.pathname})`);
    }
  } catch (l) {
  }
  return a;
}, xi = (e, t, n, r) => {
  var l;
  const i = typeof t == "string" ? t : String(t), a = e.attributes["http.url"], u = new URL(a);
  let c;
  try {
    c = t ? JSON.parse(i) : void 0, c.operationName && e.setAttribute("graphql.operation.name", c.operationName);
  } catch (f) {
  }
  const s = Yo((l = r == null ? void 0 : r.networkHeadersToRedact) != null ? l : [], n, r == null ? void 0 : r.headerKeysToRecord);
  e.setAttributes({
    "highlight.type": "http.request",
    "http.request.headers": JSON.stringify(s),
    "http.request.body": i,
    [cc]: a,
    [lc]: u.pathname,
    [fc]: u.search
  }), u.searchParams.size > 0 && e.setAttributes({
    // Custom attribute that displays query string params as an object.
    "url.query_params": JSON.stringify(Object.fromEntries(u.searchParams))
  });
}, P_ = (e, t, n, r) => r != null && r.some((o) => e.toLowerCase().includes(o)) ? !1 : zt(e, t, n), Pi = (e) => {
  const n = e.events, r = {
    unload: W("unloadEventStart", "unloadEventEnd", n),
    dom_interactive: W("domInteractive", "fetchStart", n),
    dom_content_loaded: W("domContentLoadedEventEnd", "domContentLoadedEventStart", n),
    dom_complete: W("fetchStart", "domComplete", n),
    load_event: W("loadEventStart", "loadEventEnd", n),
    first_paint: W("fetchStart", "firstPaint", n),
    first_contentful_paint: W("fetchStart", "firstContentfulPaint", n),
    domain_lookup: W("domainLookupStart", "domainLookupEnd", n),
    connect: W("connectStart", "connectEnd", n),
    request: W("requestStart", "requestEnd", n),
    response: W("responseStart", "responseEnd", n)
  };
  Object.entries(r).forEach(([i, o]) => {
    o > 0 && (e.setAttribute(`timings.${i}.ns`, o), e.setAttribute(`timings.${i}.readable`, Ca(o)));
  });
};
function W(e, t, n) {
  const r = n.find((u) => u.name === e), i = n.find((u) => u.name === t);
  if (!r || !i)
    return 0;
  const o = r.time[0] * 1e9 + r.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const M_ = (e, t) => {
  const n = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e6,
    connect: (t.connectEnd - t.connectStart) * 1e6,
    request: (t.responseEnd - t.requestStart) * 1e6,
    response: (t.responseEnd - t.responseStart) * 1e6
  };
  Object.entries(n).forEach(([r, i]) => {
    i > 0 && (e.setAttribute(`timings.${r}.ns`, i), e.setAttribute(`timings.${r}.readable`, Ca(i)));
  });
}, Ca = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, Mi = (e) => e === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(e) ? e.map((t) => typeof t == "string" ? new RegExp(t) : t) : /^$/, k_ = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var ki;
(function(e) {
  e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea";
})(ki || (ki = {}));
var Di;
(function(e) {
  e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend";
})(Di || (Di = {}));
const D_ = (e, t, n) => {
  const r = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = e;
  const i = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (o) => {
    const f = o, { message: a, size: u } = f, c = Jt(f, ["message", "size"]), l = n.some((d) => o.name.toLowerCase().includes(d)) ? c : o;
    t(l);
  }, () => {
    window._highlightWebSocketRequestCallback = r, window._highlightWebSocketEventCallback = i;
  };
}, U_ = ({ xhrCallback: e, fetchCallback: t, webSocketRequestCallback: n, webSocketEventCallback: r, disableWebSocketRecording: i, bodyKeysToRedact: o, highlightEndpoints: a, tracingOrigins: u, urlBlocklist: c, bodyKeysToRecord: s }) => {
  const l = _d(e, a, u, c, o, s), f = yd(t, a, u, c, o, s), d = i ? () => {
  } : D_(n, r, c);
  return () => {
    l(), f(), d();
  };
};
class Or {
  constructor(t) {
    b(this, "disableConsoleRecording");
    b(this, "reportConsoleErrors");
    b(this, "enablePromisePatch");
    b(this, "consoleMethodsToRecord");
    b(this, "listeners");
    b(this, "errors");
    b(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    b(this, "options");
    b(this, "hasNetworkRecording", !0);
    b(this, "disableNetworkRecording");
    b(this, "enableRecordingNetworkContents");
    b(this, "xhrNetworkContents");
    b(this, "fetchNetworkContents");
    b(this, "disableRecordingWebSocketContents");
    b(this, "webSocketNetworkContents");
    b(this, "webSocketEventContents");
    b(this, "tracingOrigins");
    b(this, "networkHeadersToRedact");
    b(this, "networkBodyKeysToRedact");
    b(this, "networkBodyKeysToRecord");
    b(this, "networkHeaderKeysToRecord");
    b(this, "lastNetworkRequestTimestamp");
    b(this, "urlBlocklist");
    b(this, "highlightEndpoints");
    b(this, "requestResponseSanitizer");
    var n, r;
    this.options = t, this.disableConsoleRecording = !!t.disableConsoleRecording, this.reportConsoleErrors = (n = t.reportConsoleErrors) != null ? n : !1, this.enablePromisePatch = (r = t.enablePromisePatch) != null ? r : !1, this.consoleMethodsToRecord = t.consoleMethodsToRecord || [
      ...k_
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening())
      return;
    const t = this;
    this.disableConsoleRecording || this.listeners.push($a((n) => {
      var r, i, o;
      if (this.reportConsoleErrors && (n.type === "Error" || n.type === "error") && n.value && n.trace) {
        const a = Nt(n.value);
        if (Ir.includes(a) || Cr.some((u) => a.includes(u)))
          return;
        t.errors.push({
          event: a,
          type: "console.error",
          url: window.location.href,
          source: (r = n.trace[0]) != null && r.fileName ? n.trace[0].fileName : "",
          lineNumber: (i = n.trace[0]) != null && i.lineNumber ? n.trace[0].lineNumber : 0,
          columnNumber: (o = n.trace[0]) != null && o.columnNumber ? n.trace[0].columnNumber : 0,
          stackTrace: n.trace,
          timestamp: (/* @__PURE__ */ new Date()).toISOString()
        });
      }
      t.messages.push(n);
    }, {
      level: this.consoleMethodsToRecord,
      logger: "console",
      stringifyOptions: {
        depthOfLimit: 10,
        numOfKeysLimit: 100,
        stringLengthLimit: 1e3
      }
    })), this.listeners.push(za((n) => {
      Ir.includes(n.event) || Cr.some((r) => n.event.includes(r)) || t.errors.push(n);
    }, { enablePromisePatch: this.enablePromisePatch })), this.listeners.push(x_), Or.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((t) => t()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(t, n) {
    var o, a, u, c, s, l, f, d, h, g, p, m;
    const r = (n == null ? void 0 : n.backendUrl) || "https://pub.highlight.run", i = n.otlpEndpoint || "https://otel.highlight.io";
    t.highlightEndpoints = [r, i], t.xhrNetworkContents = [], t.fetchNetworkContents = [], t.webSocketNetworkContents = [], t.webSocketEventContents = [], t.networkHeadersToRedact = [], t.urlBlocklist = [], t.tracingOrigins = n.tracingOrigins || [], (n == null ? void 0 : n.disableNetworkRecording) !== void 0 ? (t.disableNetworkRecording = n == null ? void 0 : n.disableNetworkRecording, t.enableRecordingNetworkContents = !1, t.disableRecordingWebSocketContents = !0, t.networkHeadersToRedact = [], t.networkBodyKeysToRedact = [], t.urlBlocklist = [], t.networkBodyKeysToRecord = []) : typeof (n == null ? void 0 : n.networkRecording) == "boolean" ? (t.disableNetworkRecording = !n.networkRecording, t.enableRecordingNetworkContents = !1, t.disableRecordingWebSocketContents = !0, t.networkHeadersToRedact = [], t.networkBodyKeysToRedact = [], t.urlBlocklist = []) : (((o = n.networkRecording) == null ? void 0 : o.enabled) !== void 0 ? t.disableNetworkRecording = !n.networkRecording.enabled : t.disableNetworkRecording = !1, t.enableRecordingNetworkContents = ((a = n.networkRecording) == null ? void 0 : a.recordHeadersAndBody) || !1, t.disableRecordingWebSocketContents = ((u = n.networkRecording) == null ? void 0 : u.disableWebSocketEventRecordings) || !1, t.networkHeadersToRedact = ((s = (c = n.networkRecording) == null ? void 0 : c.networkHeadersToRedact) == null ? void 0 : s.map((y) => y.toLowerCase())) || [], t.networkBodyKeysToRedact = ((f = (l = n.networkRecording) == null ? void 0 : l.networkBodyKeysToRedact) == null ? void 0 : f.map((y) => y.toLowerCase())) || [], t.urlBlocklist = ((h = (d = n.networkRecording) == null ? void 0 : d.urlBlocklist) == null ? void 0 : h.map((y) => y.toLowerCase())) || [], t.urlBlocklist = [
      ...t.urlBlocklist,
      ...Jo
    ], t.requestResponseSanitizer = (g = n.networkRecording) == null ? void 0 : g.requestResponseSanitizer, t.networkHeaderKeysToRecord = (p = n.networkRecording) == null ? void 0 : p.headerKeysToRecord, t.networkHeaderKeysToRecord && (t.networkHeadersToRedact = [], t.networkHeaderKeysToRecord = t.networkHeaderKeysToRecord.map((y) => y.toLocaleLowerCase())), t.networkBodyKeysToRecord = (m = n.networkRecording) == null ? void 0 : m.bodyKeysToRecord, t.networkBodyKeysToRecord && (t.networkBodyKeysToRedact = [], t.networkBodyKeysToRecord = t.networkBodyKeysToRecord.map((y) => y.toLocaleLowerCase()))), !t.disableNetworkRecording && t.enableRecordingNetworkContents && t.listeners.push(U_({
      xhrCallback: (y) => {
        t.xhrNetworkContents.push(y);
      },
      fetchCallback: (y) => {
        t.fetchNetworkContents.push(y);
      },
      webSocketRequestCallback: (y) => {
        t.webSocketNetworkContents && t.webSocketNetworkContents.push(y);
      },
      webSocketEventCallback: (y) => {
        t.webSocketEventContents.push(y);
      },
      disableWebSocketRecording: t.disableRecordingWebSocketContents,
      bodyKeysToRedact: t.networkBodyKeysToRedact,
      highlightEndpoints: t.highlightEndpoints,
      tracingOrigins: t.tracingOrigins,
      urlBlocklist: t.urlBlocklist,
      bodyKeysToRecord: t.networkBodyKeysToRecord
    }));
  }
  static getRecordedNetworkResources(t, n) {
    var o, a;
    let r = [], i = [];
    if (!t.disableNetworkRecording) {
      const u = ((o = window == null ? void 0 : window.performance) == null ? void 0 : o.timeOrigin) || 0;
      r = performance.getEntriesByType("resource");
      const c = (n - u) * 2;
      if (r = r.filter((s) => s.responseEnd < t.lastNetworkRequestTimestamp ? !1 : zt(s.name, t.highlightEndpoints, t.tracingOrigins)).map((s) => H(P({}, s.toJSON()), {
        offsetStartTime: s.startTime - c,
        offsetResponseEnd: s.responseEnd - c,
        offsetFetchStart: s.fetchStart - c
      })), t.lastNetworkRequestTimestamp = ((a = r.at(-1)) == null ? void 0 : a.responseEnd) || t.lastNetworkRequestTimestamp, t.enableRecordingNetworkContents) {
        const s = {
          headersToRedact: t.networkHeadersToRedact,
          headersToRecord: t.networkHeaderKeysToRecord,
          requestResponseSanitizer: t.requestResponseSanitizer
        };
        r = ii(r, t.xhrNetworkContents, "xmlhttprequest", s), r = ii(r, t.fetchNetworkContents, "fetch", s);
      }
    }
    return t.disableRecordingWebSocketContents || (i = t.webSocketNetworkContents || []), [...r, ...i];
  }
  static getRecordedWebSocketEvents(t) {
    let n = [];
    return !t.disableNetworkRecording && !t.disableRecordingWebSocketContents && (n = t.webSocketEventContents), n;
  }
  static clearRecordedNetworkResources(t) {
    t.disableNetworkRecording || (t.xhrNetworkContents = [], t.fetchNetworkContents = [], t.webSocketNetworkContents = [], t.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const B_ = () => {
  var o;
  const t = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var n = "";
  const r = typeof window != "undefined" && ((o = window.crypto) == null ? void 0 : o.getRandomValues), i = new Uint32Array(28);
  r && window.crypto.getRandomValues(i);
  for (let a = 0; a < 28; a++)
    r ? n += t.charAt(i[a] % t.length) : n += t.charAt(Math.floor(Math.random() * t.length));
  return n;
}, H_ = "9.9.0", F_ = () => {
  var e, t;
  typeof chrome != "undefined" && ((e = chrome == null ? void 0 : chrome.runtime) != null && e.onMessage) && ((t = chrome == null ? void 0 : chrome.runtime) == null || t.onMessage.addListener((n, r, i) => {
    const o = n.action;
    switch (console.log(`[highlight] received '${o}' event from extension.`), o) {
      case "init": {
        N.init(1, {
          debug: !0
        }), N.getSessionURL().then((a) => {
          i({ url: a });
        });
        break;
      }
      case "stop": {
        N.stop(), i({ success: !0 });
        break;
      }
    }
    return !0;
  }));
};
function ig(e) {
  var t;
  e.on && ((t = e.webContents) != null && t.send) && (e.on("focus", () => {
    e.webContents.send("highlight.run", { visible: !0 });
  }), e.on("blur", () => {
    e.webContents.send("highlight.run", { visible: !1 });
  }), e.on("close", () => {
    e.webContents.send("highlight.run", { visible: !1 });
  }));
}
const og = ({ next: e, payload: t }) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (t.obj.type === "track") {
      const n = t.obj.event, r = t.obj.properties;
      window.H.track(n, r);
    } else if (t.obj.type === "identify") {
      const n = t.obj.userId;
      if (n != null && n.length) {
        const r = t.obj.traits;
        window.H.identify(n, r);
      }
    }
  }
  e(t);
}, nr = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (e, t) => window._originalFetch(e, t), window._highlightFetchPatch = (e, t) => window._fetchProxy.call(window || global, e, t), window.fetch = window._highlightFetchPatch;
  }
}, Ui = () => null, rr = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = Ui, window._highlightWebSocketEventCallback = Ui;
    const e = new Proxy(window.WebSocket, {
      construct(t, n) {
        const [, r] = Sr(), i = new t(...n), o = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: r,
            initiatorType: "websocket",
            type: "open",
            name: i.url,
            startTimeAbs: performance.timeOrigin + l.timeStamp
          });
        }, a = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: r,
            initiatorType: "websocket",
            type: "close",
            name: i.url,
            responseEndAbs: performance.timeOrigin + l.timeStamp
          }), i.removeEventListener("open", o), i.removeEventListener("error", c), i.removeEventListener("message", u), i.removeEventListener("close", a);
        }, u = (l) => {
          const { data: f } = l, d = typeof f == "string" ? l.data : void 0;
          let h;
          typeof f == "string" ? h = f.length : f instanceof Blob ? h = f.size : h = f.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: r,
            type: "received",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: h,
            message: d
          });
        }, c = (l) => {
          window._highlightWebSocketEventCallback({
            socketId: r,
            type: "error",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: 0
          });
        };
        i.addEventListener("open", o), i.addEventListener("error", c), i.addEventListener("message", u), i.addEventListener("close", a);
        const s = new Proxy(i.send, {
          apply: function(l, f, d) {
            const h = d[0], g = typeof h == "string" ? h : void 0;
            let p;
            typeof h == "string" ? p = h.length : h instanceof Blob ? p = h.size : p = h.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: r,
              type: "sent",
              name: i.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: p,
              message: g
            }), l.apply(f, d);
          }
        });
        return i.send = s, i;
      }
    });
    window.WebSocket = e;
  }
}, Bi = () => {
  const e = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, n) => e,
    setAttributes: (t) => e,
    addEvent: (t, n, r) => e,
    addLinks: (t) => e,
    setStatus: (t) => e,
    recordException: () => {
    },
    addLink: () => e,
    updateName: () => e,
    isRecording: () => !1
  };
  return e;
};
var ir;
(function(e) {
  e.Device = "Device", e.WebVital = "WebVital", e.Frontend = "Frontend", e.Backend = "Backend";
})(ir || (ir = {}));
const F = (e, t) => {
  console.warn(`highlight.run warning: (${e}): `, t);
}, G_ = 200;
let $e = [], Rt, O, Xe, or = !1, Ve;
const N = {
  options: void 0,
  init: (e, t) => {
    var n, r, i, o, a, u, c, s;
    try {
      if (N.options = t, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!e) {
        console.info("Highlight is not initializing because projectID was passed undefined.");
        return;
      }
      t != null && t.skipCookieSessionDataLoad ? nd(!1) : ld();
      let l = mn(), f = B_();
      if (l != null && l.sessionSecureID && (f = l.sessionSecureID), or)
        return { sessionSecureID: f };
      or = !0, nr(), rr(), import("./index-D9H6ALGk.js").then((m) => j(void 0, [m], function* ({ Highlight: h, setupBrowserTracing: g, getTracer: p }) {
        var y, T, R;
        g({
          otlpEndpoint: (y = t == null ? void 0 : t.otlpEndpoint) != null ? y : "https://otel.highlight.io",
          projectId: e,
          sessionSecureId: f,
          environment: (T = t == null ? void 0 : t.environment) != null ? T : "production",
          networkRecordingOptions: typeof (t == null ? void 0 : t.networkRecording) == "object" ? t.networkRecording : void 0,
          tracingOrigins: t == null ? void 0 : t.tracingOrigins,
          serviceName: (R = t == null ? void 0 : t.serviceName) != null ? R : "highlight-browser"
        }), Ve = p, O = new h(d, Xe), nr(), rr(), t != null && t.manualStart || (yield O.initialize());
      }));
      const d = H(P({}, t), {
        organizationID: e,
        firstloadVersion: H_,
        environment: (t == null ? void 0 : t.environment) || "production",
        appVersion: t == null ? void 0 : t.version,
        sessionSecureID: f
      });
      return Xe = new Or(d), t != null && t.manualStart || Xe.startListening(), !((r = (n = t == null ? void 0 : t.integrations) == null ? void 0 : n.mixpanel) != null && r.disabled) && ((o = (i = t == null ? void 0 : t.integrations) == null ? void 0 : i.mixpanel) != null && o.projectToken) && Da(t.integrations.mixpanel), !((u = (a = t == null ? void 0 : t.integrations) == null ? void 0 : a.amplitude) != null && u.disabled) && ((s = (c = t == null ? void 0 : t.integrations) == null ? void 0 : c.amplitude) != null && s.apiKey) && ka(t.integrations.amplitude), { sessionSecureID: f };
    } catch (l) {
      F("init", l);
    }
  },
  snapshot: (e) => j(void 0, null, function* () {
    try {
      if (O && O.ready)
        return yield O.snapshot(e);
    } catch (t) {
      F("snapshot", t);
    }
  }),
  addSessionFeedback: ({ verbatim: e, userName: t, userEmail: n, timestampOverride: r }) => {
    try {
      N.onHighlightReady(() => O.addSessionFeedback({
        verbatim: e,
        timestamp: r || (/* @__PURE__ */ new Date()).toISOString(),
        user_email: n,
        user_name: t
      }));
    } catch (i) {
      F("error", i);
    }
  },
  consumeError: (e, t, n) => {
    try {
      N.onHighlightReady(() => O.consumeCustomError(e, t, JSON.stringify(n)));
    } catch (r) {
      F("error", r);
    }
  },
  consume: (e, t) => {
    try {
      N.onHighlightReady(() => O.consumeError(e, t));
    } catch (n) {
      F("error", n);
    }
  },
  error: (e, t) => {
    try {
      N.onHighlightReady(() => O.pushCustomError(e, JSON.stringify(t)));
    } catch (n) {
      F("error", n);
    }
  },
  track: (e, t = {}) => {
    var n, r, i, o, a, u, c, s, l, f, d;
    try {
      N.onHighlightReady(() => O.addProperties(H(P({}, t), { event: e })));
      const h = O == null ? void 0 : O.getCurrentSessionURL();
      (i = (r = (n = N.options) == null ? void 0 : n.integrations) == null ? void 0 : r.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.track && window.mixpanel.track(e, H(P({}, t), {
        highlightSessionURL: h
      })), (c = (u = (a = N.options) == null ? void 0 : a.integrations) == null ? void 0 : u.amplitude) != null && c.disabled || (s = window.amplitude) != null && s.getInstance && window.amplitude.getInstance().logEvent(e, H(P({}, t), {
        highlightSessionURL: h
      })), (d = (f = (l = N.options) == null ? void 0 : l.integrations) == null ? void 0 : f.intercom) != null && d.disabled || window.Intercom && window.Intercom("trackEvent", e, t);
    } catch (h) {
      F("track", h);
    }
  },
  start: (e) => {
    (O == null ? void 0 : O.state) === "Recording" && !(e != null && e.forceNew) ? e != null && e.silent || console.warn("Highlight is already recording. Please `H.stop()` the current session before starting a new one.") : (Xe.startListening(), N.onHighlightReady(() => j(void 0, null, function* () {
      yield O.initialize(e);
    }), { waitForReady: !1 }));
  },
  stop: (e) => {
    (O == null ? void 0 : O.state) !== "Recording" ? e != null && e.silent || console.warn("Highlight is already stopped. Please call `H.start()`.") : N.onHighlightReady(() => O.stopRecording(!0));
  },
  identify: (e, t = {}) => {
    var n, r, i, o, a, u, c, s;
    try {
      N.onHighlightReady(() => O.identify(e, t));
    } catch (l) {
      F("identify", l);
    }
    if ((i = (r = (n = N.options) == null ? void 0 : n.integrations) == null ? void 0 : r.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.identify && (window.mixpanel.identify(typeof (t == null ? void 0 : t.email) == "string" ? t == null ? void 0 : t.email : e), t && (window.mixpanel.track("identify", t), window.mixpanel.people.set(t))), !((c = (u = (a = N.options) == null ? void 0 : a.integrations) == null ? void 0 : u.amplitude) != null && c.disabled) && (s = window.amplitude) != null && s.getInstance && (window.amplitude.getInstance().setUserId(e), Object.keys(t).length > 0)) {
      const l = Object.keys(t).reduce((f, d) => (f.set(d, t[d]), f), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(l);
    }
  },
  metrics: (e) => {
    try {
      for (const t of e)
        N.recordMetric(t);
    } catch (t) {
      F("metrics", t);
    }
  },
  recordMetric: (e) => {
    try {
      N.onHighlightReady(() => {
        var t;
        O.recordGauge(H(P({}, e), {
          tags: (t = e.tags) != null ? t : [],
          group: window.location.href,
          category: ir.Frontend
        }));
      });
    } catch (t) {
      F("recordMetric", t);
    }
  },
  recordCount: (e) => {
    try {
      N.onHighlightReady(() => {
        O.recordCount(e);
      });
    } catch (t) {
      F("recordCount", t);
    }
  },
  recordIncr: (e) => {
    try {
      N.onHighlightReady(() => {
        O.recordIncr(e);
      });
    } catch (t) {
      F("recordIncr", t);
    }
  },
  recordHistogram: (e) => {
    try {
      N.onHighlightReady(() => {
        O.recordHistogram(e);
      });
    } catch (t) {
      F("recordHistogram", t);
    }
  },
  recordUpDownCounter: (e) => {
    try {
      N.onHighlightReady(() => {
        O.recordUpDownCounter(e);
      });
    } catch (t) {
      F("recordUpDownCounter", t);
    }
  },
  startSpan: (e, t, n, r) => {
    const i = typeof Ve == "function" ? Ve() : void 0;
    if (!i) {
      const a = Bi();
      return r === void 0 && n === void 0 ? t(a) : r === void 0 ? n(a) : r(a);
    }
    const o = (a, u) => {
      const c = u(a);
      return c instanceof Promise ? c.finally(() => a.end()) : (a.end(), c);
    };
    return r === void 0 && n === void 0 ? i.startActiveSpan(e, (a) => o(a, t)) : r === void 0 ? i.startActiveSpan(e, t, (a) => o(a, n)) : i.startActiveSpan(e, t, n, (a) => o(a, r));
  },
  startManualSpan: (e, t, n, r) => {
    const i = typeof Ve == "function" ? Ve() : void 0;
    if (!i) {
      const o = Bi();
      return r === void 0 && n === void 0 ? t(o) : r === void 0 ? n(o) : r(o);
    }
    return r === void 0 && n === void 0 ? i.startActiveSpan(e, t) : r === void 0 ? i.startActiveSpan(e, t, n) : i.startActiveSpan(e, t, n, r);
  },
  getSessionURL: () => new Promise((e, t) => {
    N.onHighlightReady(() => {
      const n = O.sessionData.sessionSecureID, r = mn(n);
      r ? e(`https://${Ba}/${r.projectID}/sessions/${n}`) : t(new Error(`Unable to get session URL: ${n}`));
    });
  }),
  getSessionDetails: () => new Promise((e, t) => {
    N.onHighlightReady(() => j(void 0, null, function* () {
      try {
        const n = yield N.getSessionURL();
        if (!n)
          throw new Error("Could not get session URL");
        const r = O.sessionData.sessionSecureID, i = mn(r), o = i == null ? void 0 : i.sessionStartTime;
        if (!o)
          throw new Error("Could not get session start timestamp");
        const a = (/* @__PURE__ */ new Date()).getTime(), u = new URL(n), c = new URL(n);
        c.searchParams.set("ts", ((a - o) / 1e3).toString()), e({
          url: u.toString(),
          urlWithTimestamp: c.toString(),
          sessionSecureID: r
        });
      } catch (n) {
        t(n);
      }
    }));
  }),
  getRecordingState: () => {
    var e;
    return (e = O == null ? void 0 : O.state) != null ? e : "NotRecording";
  },
  onHighlightReady: (e, t) => {
    if (O && O.ready) {
      e();
      return;
    }
    if ($e.push({ options: t, func: e }), Rt !== void 0)
      return;
    const n = () => {
      $e = $e.filter((i) => {
        var o;
        return !O || ((o = i.options) == null ? void 0 : o.waitForReady) !== !1 && !O.ready ? !0 : (i.func(), !1);
      }), Rt = void 0, $e.length > 0 && (Rt = setTimeout(n, G_));
    };
    n();
  }
};
typeof window != "undefined" && (window.H = N);
F_();
nr();
rr();
const ag = {
  reset: () => {
    or = !1, O = void 0, $e = [], Rt = void 0, Xe = void 0;
  },
  setHighlightObj: (e) => {
    O = e;
  }
};
export {
  ng as A,
  tg as B,
  Ke as C,
  ig as D,
  N as E,
  Or as F,
  B_ as G,
  Ba as H,
  og as I,
  ir as J,
  E as K,
  ki as M,
  Af as Q,
  ke as S,
  q_ as V,
  ag as _,
  jo as a,
  Jf as b,
  Fi as c,
  _n as d,
  zo as e,
  mn as f,
  Gi as g,
  W_ as h,
  J_ as i,
  Cn as j,
  sd as k,
  cd as l,
  Z_ as m,
  j_ as n,
  Di as o,
  K_ as p,
  rg as q,
  rd as r,
  qo as s,
  X_ as t,
  $_ as u,
  Nt as v,
  eg as w,
  z_ as x,
  Q_ as y,
  nd as z
};
//# sourceMappingURL=index-DP-CTkpL.js.map
